/**
 * CNAE-Subclasses 2.3 (Classificação Nacional de Atividades Econômicas) subclasses, indexed by
 * the raw 7 digit code, mapping to the official subclass description.
 *
 * 2.3 is the current subclass revision of CNAE 2.0: CONCLA's own CNAE browser lists it as
 * "CNAE-Subclasses 2.3" under "CNAE 2.0 (Res 02/2010)" and tells anyone opening an older table
 * that the "Versões atuais da CNAE" are "CNAE 2.0 (Res 02/2010)" and "CNAE-Subclasses 2.3". The
 * classification's landing page still describes the parent CNAE 2.0 itself ("Base Legal:
 * Resolução Concla 01/2006", 1301 subclasses); the 1332 subclasses below are the ones the IBGE
 * data service publishes for the 2.3 revision.
 *
 * Generated by `node ./scripts/cnae.ts`. Do not edit by hand.
 *
 * @see Official: https://servicodados.ibge.gov.br/api/v2/cnae/subclasses
 * @see Official: https://concla.ibge.gov.br/busca-online-cnae.html
 * CONCLA's CNAE search and structure browser, which publishes CNAE-Subclasses 2.3.
 * @see Official: https://concla.ibge.gov.br/classificacoes/por-tema/atividades-economicas/classificacao-nacional-de-atividades-economicas
 * CNAE 2.0, the parent classification the 2.3 subclass revision belongs to.
 */
export const CNAE_SUBCLASSES: Record<string, string> = {
	"1011201": "FRIGORÍFICO - ABATE DE BOVINOS",
	"1011202": "FRIGORÍFICO - ABATE DE EQÜINOS",
	"1011203": "FRIGORÍFICO - ABATE DE OVINOS E CAPRINOS",
	"1011204": "FRIGORÍFICO - ABATE DE BUFALINOS",
	"1011205": "MATADOURO - ABATE DE RESES SOB CONTRATO - EXCETO ABATE DE SUÍNOS",
	"1012101": "ABATE DE AVES",
	"1012102": "ABATE DE PEQUENOS ANIMAIS",
	"1012103": "FRIGORÍFICO - ABATE DE SUÍNOS",
	"1012104": "MATADOURO - ABATE DE SUÍNOS SOB CONTRATO",
	"1013901": "FABRICAÇÃO DE PRODUTOS DE CARNE",
	"1013902": "PREPARAÇÃO DE SUBPRODUTOS DO ABATE",
	"1020101": "PRESERVAÇÃO DE PEIXES, CRUSTÁCEOS E MOLUSCOS",
	"1020102": "FABRICAÇÃO DE CONSERVAS DE PEIXES, CRUSTÁCEOS E MOLUSCOS",
	"1031700": "FABRICAÇÃO DE CONSERVAS DE FRUTAS",
	"1032501": "FABRICAÇÃO DE CONSERVAS DE PALMITO",
	"1032599": "FABRICAÇÃO DE CONSERVAS DE LEGUMES E OUTROS VEGETAIS, EXCETO PALMITO",
	"1033301": "FABRICAÇÃO DE SUCOS CONCENTRADOS DE FRUTAS, HORTALIÇAS E LEGUMES",
	"1033302": "FABRICAÇÃO DE SUCOS DE FRUTAS, HORTALIÇAS E LEGUMES, EXCETO CONCENTRADOS",
	"1041400": "FABRICAÇÃO DE ÓLEOS VEGETAIS EM BRUTO, EXCETO ÓLEO DE MILHO",
	"1042200": "FABRICAÇÃO DE ÓLEOS VEGETAIS REFINADOS, EXCETO ÓLEO DE MILHO",
	"1043100":
		"FABRICAÇÃO DE MARGARINA E OUTRAS GORDURAS VEGETAIS E DE ÓLEOS NÃO COMESTÍVEIS DE ANIMAIS",
	"1051100": "PREPARAÇÃO DO LEITE",
	"1052000": "FABRICAÇÃO DE LATICÍNIOS",
	"1053800": "FABRICAÇÃO DE SORVETES E OUTROS GELADOS COMESTÍVEIS",
	"1061901": "BENEFICIAMENTO DE ARROZ",
	"1061902": "FABRICAÇÃO DE PRODUTOS DO ARROZ",
	"1062700": "MOAGEM DE TRIGO E FABRICAÇÃO DE DERIVADOS",
	"1063500": "FABRICAÇÃO DE FARINHA DE MANDIOCA E DERIVADOS",
	"1064300": "FABRICAÇÃO DE FARINHA DE MILHO E DERIVADOS, EXCETO ÓLEOS DE MILHO",
	"1065101": "FABRICAÇÃO DE AMIDOS E FÉCULAS DE VEGETAIS",
	"1065102": "FABRICAÇÃO DE ÓLEO DE MILHO EM BRUTO",
	"1065103": "FABRICAÇÃO DE ÓLEO DE MILHO REFINADO",
	"1066000": "FABRICAÇÃO DE ALIMENTOS PARA ANIMAIS",
	"1069400": "MOAGEM E FABRICAÇÃO DE PRODUTOS DE ORIGEM VEGETAL NÃO ESPECIFICADOS ANTERIORMENTE",
	"1071600": "FABRICAÇÃO DE AÇÚCAR EM BRUTO",
	"1072401": "FABRICAÇÃO DE AÇÚCAR DE CANA REFINADO",
	"1072402": "FABRICAÇÃO DE AÇÚCAR DE CEREAIS (DEXTROSE) E DE BETERRABA",
	"1081301": "BENEFICIAMENTO DE CAFÉ",
	"1081302": "TORREFAÇÃO E MOAGEM DE CAFÉ",
	"1082100": "FABRICAÇÃO DE PRODUTOS À BASE DE CAFÉ",
	"1091101": "FABRICAÇÃO DE PRODUTOS DE PANIFICAÇÃO INDUSTRIAL",
	"1091102":
		"FABRICAÇÃO DE PRODUTOS DE PADARIA E CONFEITARIA COM PREDOMINÂNCIA  DE PRODUÇÃO PRÓPRIA",
	"1092900": "FABRICAÇÃO DE BISCOITOS E BOLACHAS",
	"1093701": "FABRICAÇÃO DE PRODUTOS DERIVADOS DO CACAU E DE CHOCOLATES",
	"1093702": "FABRICAÇÃO DE FRUTAS CRISTALIZADAS, BALAS E SEMELHANTES",
	"1094500": "FABRICAÇÃO DE MASSAS ALIMENTÍCIAS",
	"1095300": "FABRICAÇÃO DE ESPECIARIAS, MOLHOS, TEMPEROS E CONDIMENTOS",
	"1096100": "FABRICAÇÃO DE ALIMENTOS E PRATOS PRONTOS",
	"1099601": "FABRICAÇÃO DE VINAGRES",
	"1099602": "FABRICAÇÃO DE PÓS ALIMENTÍCIOS",
	"1099603": "FABRICAÇÃO DE FERMENTOS E LEVEDURAS",
	"1099604": "FABRICAÇÃO DE GELO COMUM",
	"1099605": "FABRICAÇÃO DE PRODUTOS PARA INFUSÃO (CHÁ, MATE, ETC.)",
	"1099606": "FABRICAÇÃO DE ADOÇANTES NATURAIS E ARTIFICIAIS",
	"1099607": "FABRICAÇÃO DE ALIMENTOS DIETÉTICOS E COMPLEMENTOS ALIMENTARES",
	"1099699": "FABRICAÇÃO DE OUTROS PRODUTOS ALIMENTÍCIOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"1111901": "FABRICAÇÃO DE AGUARDENTE DE CANA DE AÇÚCAR",
	"1111902": "FABRICAÇÃO DE OUTRAS AGUARDENTES E BEBIDAS DESTILADAS",
	"1112700": "FABRICAÇÃO DE VINHO",
	"1113501": "FABRICAÇÃO DE MALTE, INCLUSIVE MALTE UÍSQUE",
	"1113502": "FABRICAÇÃO DE CERVEJAS E CHOPES",
	"1121600": "FABRICAÇÃO DE ÁGUAS ENVASADAS",
	"1122401": "FABRICAÇÃO DE REFRIGERANTES",
	"1122402": "FABRICAÇÃO DE CHÁ MATE E OUTROS CHÁS PRONTOS PARA CONSUMO",
	"1122403": "FABRICAÇÃO DE REFRESCOS, XAROPES E PÓS PARA REFRESCOS, EXCETO REFRESCOS DE FRUTAS",
	"1122404": "FABRICAÇÃO DE BEBIDAS ISOTÔNICAS",
	"1122499": "FABRICAÇÃO DE OUTRAS BEBIDAS NÃO ALCOÓLICAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"1210700": "PROCESSAMENTO INDUSTRIAL DO FUMO",
	"1220401": "FABRICAÇÃO DE CIGARROS",
	"1220402": "FABRICAÇÃO DE CIGARRILHAS E CHARUTOS",
	"1220403": "FABRICAÇÃO DE FILTROS PARA CIGARROS",
	"1220499": "FABRICAÇÃO DE OUTROS PRODUTOS DO FUMO, EXCETO CIGARROS, CIGARRILHAS E CHARUTOS",
	"1311100": "PREPARAÇÃO E FIAÇÃO DE FIBRAS DE ALGODÃO",
	"1312000": "PREPARAÇÃO E FIAÇÃO DE FIBRAS TÊXTEIS NATURAIS, EXCETO ALGODÃO",
	"1313800": "FIAÇÃO DE FIBRAS ARTIFICIAIS E SINTÉTICAS",
	"1314600": "FABRICAÇÃO DE LINHAS PARA COSTURAR E BORDAR",
	"1321900": "TECELAGEM DE FIOS DE ALGODÃO",
	"1322700": "TECELAGEM DE FIOS DE FIBRAS TÊXTEIS NATURAIS, EXCETO ALGODÃO",
	"1323500": "TECELAGEM DE FIOS DE FIBRAS ARTIFICIAIS E SINTÉTICAS",
	"1330800": "FABRICAÇÃO DE TECIDOS DE MALHA",
	"1340501": "ESTAMPARIA E TEXTURIZAÇÃO EM FIOS, TECIDOS, ARTEFATOS TÊXTEIS E PEÇAS DO VESTUÁRIO",
	"1340502":
		"ALVEJAMENTO, TINGIMENTO E TORÇÃO EM FIOS, TECIDOS, ARTEFATOS TÊXTEIS E PEÇAS DO VESTUÁRIO",
	"1340599":
		"OUTROS SERVIÇOS DE ACABAMENTO EM FIOS, TECIDOS, ARTEFATOS TÊXTEIS E PEÇAS DO VESTUÁRIO",
	"1351100": "FABRICAÇÃO DE ARTEFATOS TÊXTEIS PARA USO DOMÉSTICO",
	"1352900": "FABRICAÇÃO DE ARTEFATOS DE TAPEÇARIA",
	"1353700": "FABRICAÇÃO DE ARTEFATOS DE CORDOARIA",
	"1354500": "FABRICAÇÃO DE TECIDOS ESPECIAIS, INCLUSIVE ARTEFATOS",
	"1359600": "FABRICAÇÃO DE OUTROS PRODUTOS TÊXTEIS NÃO ESPECIFICADOS ANTERIORMENTE",
	"1411801": "CONFECÇÃO DE ROUPAS ÍNTIMAS",
	"1411802": "FACÇÃO DE ROUPAS ÍNTIMAS",
	"1412601":
		"CONFECÇÃO DE PEÇAS DE VESTUÁRIO, EXCETO ROUPAS ÍNTIMAS E AS CONFECCIONADAS SOB MEDIDA",
	"1412602": "CONFECÇÃO, SOB MEDIDA, DE PEÇAS DO VESTUÁRIO, EXCETO ROUPAS ÍNTIMAS",
	"1412603": "FACÇÃO DE PEÇAS DO VESTUÁRIO, EXCETO ROUPAS ÍNTIMAS",
	"1413401": "CONFECÇÃO DE ROUPAS PROFISSIONAIS, EXCETO SOB MEDIDA",
	"1413402": "CONFECÇÃO, SOB MEDIDA, DE ROUPAS PROFISSIONAIS",
	"1413403": "FACÇÃO DE ROUPAS PROFISSIONAIS",
	"1414200": "FABRICAÇÃO DE ACESSÓRIOS DO VESTUÁRIO, EXCETO PARA SEGURANÇA E PROTEÇÃO",
	"1421500": "FABRICAÇÃO DE MEIAS",
	"1422300":
		"FABRICAÇÃO DE ARTIGOS DO VESTUÁRIO, PRODUZIDOS EM MALHARIAS E TRICOTAGENS, EXCETO MEIAS",
	"1510600": "CURTIMENTO E OUTRAS PREPARAÇÕES DE COURO",
	"1521100": "FABRICAÇÃO DE ARTIGOS PARA VIAGEM, BOLSAS E SEMELHANTES DE QUALQUER MATERIAL",
	"1529700": "FABRICAÇÃO DE ARTEFATOS DE COURO NÃO ESPECIFICADOS ANTERIORMENTE",
	"1531901": "FABRICAÇÃO DE CALÇADOS DE COURO",
	"1531902": "ACABAMENTO DE CALÇADOS DE COURO SOB CONTRATO",
	"1532700": "FABRICAÇÃO DE TÊNIS DE QUALQUER MATERIAL",
	"1533500": "FABRICAÇÃO DE CALÇADOS DE MATERIAL SINTÉTICO",
	"1539400": "FABRICAÇÃO DE CALÇADOS DE MATERIAIS NÃO ESPECIFICADOS ANTERIORMENTE",
	"1540800": "FABRICAÇÃO DE PARTES PARA CALÇADOS, DE QUALQUER MATERIAL",
	"1610203": "SERRARIAS COM DESDOBRAMENTO DE MADEIRA EM BRUTO",
	"1610204": "SERRARIAS SEM DESDOBRAMENTO DE MADEIRA EM BRUTO - RESSERRAGEM",
	"1610205": "SERVIÇO DE TRATAMENTO DE MADEIRA REALIZADO SOB CONTRATO",
	"1621800":
		"FABRICAÇÃO DE MADEIRA LAMINADA E DE CHAPAS DE MADEIRA COMPENSADA, PRENSADA E AGLOMERADA",
	"1622601": "FABRICAÇÃO DE CASAS DE MADEIRA PRÉ FABRICADAS",
	"1622602":
		"FABRICAÇÃO DE ESQUADRIAS DE MADEIRA E DE PEÇAS DE MADEIRA PARA INSTALAÇÕES INDUSTRIAIS E COMERCIAIS",
	"1622699": "FABRICAÇÃO DE OUTROS ARTIGOS DE CARPINTARIA PARA CONSTRUÇÃO",
	"1623400": "FABRICAÇÃO DE ARTEFATOS DE TANOARIA E DE EMBALAGENS DE MADEIRA",
	"1629301": "FABRICAÇÃO DE ARTEFATOS DIVERSOS DE MADEIRA, EXCETO MÓVEIS",
	"1629302":
		"FABRICAÇÃO DE ARTEFATOS DIVERSOS DE CORTIÇA, BAMBU, PALHA, VIME E OUTROS MATERIAIS TRANÇADOS, EXCETO MÓVEIS",
	"1710900": "FABRICAÇÃO DE CELULOSE E OUTRAS PASTAS PARA A FABRICAÇÃO DE PAPEL",
	"1721400": "FABRICAÇÃO DE PAPEL",
	"1722200": "FABRICAÇÃO DE CARTOLINA E PAPEL CARTÃO",
	"1731100": "FABRICAÇÃO DE EMBALAGENS DE PAPEL",
	"1732000": "FABRICAÇÃO DE EMBALAGENS DE CARTOLINA E PAPEL CARTÃO",
	"1733800": "FABRICAÇÃO DE CHAPAS E DE EMBALAGENS DE PAPELÃO ONDULADO",
	"1741901": "FABRICAÇÃO DE FORMULÁRIOS CONTÍNUOS",
	"1741902":
		"FABRICAÇÃO DE PRODUTOS DE PAPEL, CARTOLINA, PAPEL CARTÃO E PAPELÃO ONDULADO PARA USO COMERCIAL E DE ESCRITÓRIO",
	"1742701": "FABRICAÇÃO DE FRALDAS DESCARTÁVEIS",
	"1742702": "FABRICAÇÃO DE ABSORVENTES HIGIÊNICOS",
	"1742799":
		"FABRICAÇÃO DE PRODUTOS DE PAPEL PARA USO DOMÉSTICO E HIGIÊNICO SANITÁRIO NÃO ESPECIFICADOS ANTERIORMENTE",
	"1749400":
		"FABRICAÇÃO DE PRODUTOS DE PASTAS CELULÓSICAS, PAPEL, CARTOLINA, PAPEL CARTÃO E PAPELÃO ONDULADO NÃO ESPECIFICADOS ANTERIORMENTE",
	"1811301": "IMPRESSÃO DE JORNAIS",
	"1811302": "IMPRESSÃO DE LIVROS, REVISTAS E OUTRAS PUBLICAÇÕES PERIÓDICAS",
	"1812100": "IMPRESSÃO DE MATERIAL DE SEGURANÇA",
	"1813001": "IMPRESSÃO DE MATERIAL PARA USO PUBLICITÁRIO",
	"1813099": "IMPRESSÃO DE MATERIAL PARA OUTROS USOS",
	"1821100": "SERVIÇOS DE PRÉ IMPRESSÃO",
	"1822901": "SERVIÇOS DE ENCADERNAÇÃO E PLASTIFICAÇÃO",
	"1822999": "SERVIÇOS DE ACABAMENTOS GRÁFICOS, EXCETO ENCADERNAÇÃO E PLASTIFICAÇÃO",
	"1830001": "REPRODUÇÃO DE SOM EM QUALQUER SUPORTE",
	"1830002": "REPRODUÇÃO DE VÍDEO EM QUALQUER SUPORTE",
	"1830003": "REPRODUÇÃO DE SOFTWARE EM QUALQUER SUPORTE",
	"1910100": "COQUERIAS",
	"1921700": "FABRICAÇÃO DE PRODUTOS DO REFINO DE PETRÓLEO",
	"1922501": "FORMULAÇÃO DE COMBUSTÍVEIS",
	"1922502": "RERREFINO DE ÓLEOS LUBRIFICANTES",
	"1922599": "FABRICAÇÃO DE OUTROS PRODUTOS DERIVADOS DO PETRÓLEO, EXCETO PRODUTOS DO REFINO",
	"1931400": "FABRICAÇÃO DE ÁLCOOL",
	"1932200": "FABRICAÇÃO DE BIOCOMBUSTÍVEIS, EXCETO ÁLCOOL",
	"2011800": "FABRICAÇÃO DE CLORO E ÁLCALIS",
	"2012600": "FABRICAÇÃO DE INTERMEDIÁRIOS PARA FERTILIZANTES",
	"2013401": "FABRICAÇÃO DE ADUBOS E FERTILIZANTES ORGANOMINERAIS",
	"2013402": "FABRICAÇÃO DE ADUBOS E FERTILIZANTES, EXCETO ORGANOMINERAIS",
	"2014200": "FABRICAÇÃO DE GASES INDUSTRIAIS",
	"2019301": "ELABORAÇÃO DE COMBUSTÍVEIS NUCLEARES",
	"2019399": "FABRICAÇÃO DE OUTROS PRODUTOS QUÍMICOS INORGÂNICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2021500": "FABRICAÇÃO DE PRODUTOS PETROQUÍMICOS BÁSICOS",
	"2022300": "FABRICAÇÃO DE INTERMEDIÁRIOS PARA PLASTIFICANTES, RESINAS E FIBRAS",
	"2029100": "FABRICAÇÃO DE PRODUTOS QUÍMICOS ORGÂNICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2031200": "FABRICAÇÃO DE RESINAS TERMOPLÁSTICAS",
	"2032100": "FABRICAÇÃO DE RESINAS TERMOFIXAS",
	"2033900": "FABRICAÇÃO DE ELASTÔMEROS",
	"2040100": "FABRICAÇÃO DE FIBRAS ARTIFICIAIS E SINTÉTICAS",
	"2051700": "FABRICAÇÃO DE DEFENSIVOS AGRÍCOLAS",
	"2052500": "FABRICAÇÃO DE DESINFESTANTES DOMISSANITÁRIOS",
	"2061400": "FABRICAÇÃO DE SABÕES E DETERGENTES SINTÉTICOS",
	"2062200": "FABRICAÇÃO DE PRODUTOS DE LIMPEZA E POLIMENTO",
	"2063100": "FABRICAÇÃO DE COSMÉTICOS, PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL",
	"2071100": "FABRICAÇÃO DE TINTAS, VERNIZES, ESMALTES E LACAS",
	"2072000": "FABRICAÇÃO DE TINTAS DE IMPRESSÃO",
	"2073800": "FABRICAÇÃO DE IMPERMEABILIZANTES, SOLVENTES E PRODUTOS AFINS",
	"2091600": "FABRICAÇÃO DE ADESIVOS E SELANTES",
	"2092401": "FABRICAÇÃO DE PÓLVORAS, EXPLOSIVOS E DETONANTES",
	"2092402": "FABRICAÇÃO DE ARTIGOS PIROTÉCNICOS",
	"2092403": "FABRICAÇÃO DE FÓSFOROS DE SEGURANÇA",
	"2093200": "FABRICAÇÃO DE ADITIVOS DE USO INDUSTRIAL",
	"2094100": "FABRICAÇÃO DE CATALISADORES",
	"2099101":
		"FABRICAÇÃO DE CHAPAS, FILMES, PAPÉIS E OUTROS MATERIAIS E PRODUTOS QUÍMICOS PARA FOTOGRAFIA",
	"2099199": "FABRICAÇÃO DE OUTROS PRODUTOS QUÍMICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2110600": "FABRICAÇÃO DE PRODUTOS FARMOQUÍMICOS",
	"2121101": "FABRICAÇÃO DE MEDICAMENTOS ALOPÁTICOS PARA USO HUMANO",
	"2121102": "FABRICAÇÃO DE MEDICAMENTOS HOMEOPÁTICOS PARA USO HUMANO",
	"2121103": "FABRICAÇÃO DE MEDICAMENTOS FITOTERÁPICOS PARA USO HUMANO",
	"2122000": "FABRICAÇÃO DE MEDICAMENTOS PARA USO VETERINÁRIO",
	"2123800": "FABRICAÇÃO DE PREPARAÇÕES FARMACÊUTICAS",
	"2211100": "FABRICAÇÃO DE PNEUMÁTICOS E DE CÂMARAS DE AR",
	"2212900": "REFORMA DE PNEUMÁTICOS USADOS",
	"2219600": "FABRICAÇÃO DE ARTEFATOS DE BORRACHA NÃO ESPECIFICADOS ANTERIORMENTE",
	"2221800": "FABRICAÇÃO DE LAMINADOS PLANOS E TUBULARES DE MATERIAL PLÁSTICO",
	"2222600": "FABRICAÇÃO DE EMBALAGENS DE MATERIAL PLÁSTICO",
	"2223400": "FABRICAÇÃO DE TUBOS E ACESSÓRIOS DE MATERIAL PLÁSTICO PARA USO NA CONSTRUÇÃO",
	"2229301": "FABRICAÇÃO DE ARTEFATOS DE MATERIAL PLÁSTICO PARA USO PESSOAL E DOMÉSTICO",
	"2229302": "FABRICAÇÃO DE ARTEFATOS DE MATERIAL PLÁSTICO PARA USOS INDUSTRIAIS",
	"2229303":
		"FABRICAÇÃO DE ARTEFATOS DE MATERIAL PLÁSTICO PARA USO NA CONSTRUÇÃO, EXCETO TUBOS E ACESSÓRIOS",
	"2229399":
		"FABRICAÇÃO DE ARTEFATOS DE MATERIAL PLÁSTICO PARA OUTROS USOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2311700": "FABRICAÇÃO DE VIDRO PLANO E DE SEGURANÇA",
	"2312500": "FABRICAÇÃO DE EMBALAGENS DE VIDRO",
	"2319200": "FABRICAÇÃO DE ARTIGOS DE VIDRO",
	"2320600": "FABRICAÇÃO DE CIMENTO",
	"2330301": "FABRICAÇÃO DE ESTRUTURAS PRÉ MOLDADAS DE CONCRETO ARMADO, EM SÉRIE E SOB ENCOMENDA",
	"2330302": "FABRICAÇÃO DE ARTEFATOS DE CIMENTO PARA USO NA CONSTRUÇÃO",
	"2330303": "FABRICAÇÃO DE ARTEFATOS DE FIBROCIMENTO PARA USO NA CONSTRUÇÃO",
	"2330304": "FABRICAÇÃO DE CASAS PRÉ MOLDADAS DE CONCRETO",
	"2330305": "PREPARAÇÃO DE MASSA DE CONCRETO E ARGAMASSA PARA CONSTRUÇÃO",
	"2330399":
		"FABRICAÇÃO DE OUTROS ARTEFATOS E PRODUTOS DE CONCRETO, CIMENTO, FIBROCIMENTO, GESSO E MATERIAIS SEMELHANTES",
	"2341900": "FABRICAÇÃO DE PRODUTOS CERÂMICOS REFRATÁRIOS",
	"2342701": "FABRICAÇÃO DE AZULEJOS E PISOS",
	"2342702":
		"FABRICAÇÃO DE ARTEFATOS DE CERÂMICA E BARRO COZIDO PARA USO NA CONSTRUÇÃO, EXCETO AZULEJOS E PISOS",
	"2349401": "FABRICAÇÃO DE MATERIAL SANITÁRIO DE CERÂMICA",
	"2349499": "FABRICAÇÃO DE PRODUTOS CERÂMICOS NÃO REFRATÁRIOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2391501": "BRITAMENTO DE PEDRAS, EXCETO ASSOCIADO À EXTRAÇÃO",
	"2391502": "APARELHAMENTO DE PEDRAS PARA CONSTRUÇÃO, EXCETO ASSOCIADO À EXTRAÇÃO",
	"2391503":
		"APARELHAMENTO DE PLACAS E EXECUÇÃO DE TRABALHOS EM MÁRMORE, GRANITO, ARDÓSIA E OUTRAS PEDRAS",
	"2392300": "FABRICAÇÃO DE CAL E GESSO",
	"2399101":
		"DECORAÇÃO, LAPIDAÇÃO, GRAVAÇÃO, VITRIFICAÇÃO E OUTROS TRABALHOS EM CERÂMICA, LOUÇA, VIDRO E CRISTAL",
	"2399102": "FABRICAÇÃO DE ABRASIVOS",
	"2399199":
		"FABRICAÇÃO DE OUTROS PRODUTOS DE MINERAIS NÃO METÁLICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2411300": "PRODUÇÃO DE FERRO GUSA",
	"2412100": "PRODUÇÃO DE FERROLIGAS",
	"2421100": "PRODUÇÃO DE SEMI ACABADOS DE AÇO",
	"2422901": "PRODUÇÃO DE LAMINADOS PLANOS DE AÇO AO CARBONO, REVESTIDOS OU NÃO",
	"2422902": "PRODUÇÃO DE LAMINADOS PLANOS DE AÇOS ESPECIAIS",
	"2423701": "PRODUÇÃO DE TUBOS DE AÇO SEM COSTURA",
	"2423702": "PRODUÇÃO DE LAMINADOS LONGOS DE AÇO, EXCETO TUBOS",
	"2424501": "PRODUÇÃO DE ARAMES DE AÇO",
	"2424502": "PRODUÇÃO DE RELAMINADOS, TREFILADOS E PERFILADOS DE AÇO, EXCETO ARAMES",
	"2431800": "PRODUÇÃO DE TUBOS DE AÇO COM COSTURA",
	"2439300": "PRODUÇÃO DE OUTROS TUBOS DE FERRO E AÇO",
	"2441501": "PRODUÇÃO DE ALUMÍNIO E SUAS LIGAS EM FORMAS PRIMÁRIAS",
	"2441502": "PRODUÇÃO DE LAMINADOS DE ALUMÍNIO",
	"2442300": "METALURGIA DOS METAIS PRECIOSOS",
	"2443100": "METALURGIA DO COBRE",
	"2449101": "PRODUÇÃO DE ZINCO EM FORMAS PRIMÁRIAS",
	"2449102": "PRODUÇÃO DE LAMINADOS DE ZINCO",
	"2449103": "FABRICAÇÃO DE ÂNODOS PARA GALVANOPLASTIA",
	"2449199":
		"METALURGIA DE OUTROS METAIS NÃO FERROSOS E SUAS LIGAS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2451200": "FUNDIÇÃO DE FERRO E AÇO",
	"2452100": "FUNDIÇÃO DE METAIS NÃO FERROSOS E SUAS LIGAS",
	"2511000": "FABRICAÇÃO DE ESTRUTURAS METÁLICAS",
	"2512800": "FABRICAÇÃO DE ESQUADRIAS DE METAL",
	"2513600": "FABRICAÇÃO DE OBRAS DE CALDEIRARIA PESADA",
	"2521700": "FABRICAÇÃO DE TANQUES, RESERVATÓRIOS METÁLICOS E CALDEIRAS PARA AQUECIMENTO CENTRAL",
	"2522500":
		"FABRICAÇÃO DE CALDEIRAS GERADORAS DE VAPOR, EXCETO PARA AQUECIMENTO CENTRAL E PARA VEÍCULOS",
	"2531401": "PRODUÇÃO DE FORJADOS DE AÇO",
	"2531402": "PRODUÇÃO DE FORJADOS DE METAIS NÃO FERROSOS E SUAS LIGAS",
	"2532201": "PRODUÇÃO DE ARTEFATOS ESTAMPADOS DE METAL",
	"2532202": "METALURGIA DO PÓ",
	"2539001": "SERVIÇOS DE USINAGEM, TORNEARIA E SOLDA",
	"2539002": "SERVIÇOS DE TRATAMENTO E REVESTIMENTO EM METAIS",
	"2541100": "FABRICAÇÃO DE ARTIGOS DE CUTELARIA",
	"2542000": "FABRICAÇÃO DE ARTIGOS DE SERRALHERIA, EXCETO ESQUADRIAS",
	"2543800": "FABRICAÇÃO DE FERRAMENTAS",
	"2550101": "FABRICAÇÃO DE EQUIPAMENTO BÉLICO PESADO, EXCETO VEÍCULOS MILITARES DE COMBATE",
	"2550102": "FABRICAÇÃO DE ARMAS DE FOGO, OUTRAS ARMAS  E MUNIÇÕES",
	"2591800": "FABRICAÇÃO DE EMBALAGENS METÁLICAS",
	"2592601": "FABRICAÇÃO DE PRODUTOS DE TREFILADOS DE METAL PADRONIZADOS",
	"2592602": "FABRICAÇÃO DE PRODUTOS DE TREFILADOS DE METAL, EXCETO PADRONIZADOS",
	"2593400": "FABRICAÇÃO DE ARTIGOS DE METAL PARA USO DOMÉSTICO E PESSOAL",
	"2599301": "SERVIÇOS DE CONFECÇÃO DE ARMAÇÕES METÁLICAS PARA A CONSTRUÇÃO",
	"2599302": "SERVIÇO DE CORTE E DOBRA DE METAIS",
	"2599399": "FABRICAÇÃO DE OUTROS PRODUTOS DE METAL NÃO ESPECIFICADOS ANTERIORMENTE",
	"2610800": "FABRICAÇÃO DE COMPONENTES ELETRÔNICOS",
	"2621300": "FABRICAÇÃO DE EQUIPAMENTOS DE INFORMÁTICA",
	"2622100": "FABRICAÇÃO DE PERIFÉRICOS PARA EQUIPAMENTOS DE INFORMÁTICA",
	"2631100": "FABRICAÇÃO DE EQUIPAMENTOS TRANSMISSORES DE COMUNICAÇÃO, PEÇAS E ACESSÓRIOS",
	"2632900":
		"FABRICAÇÃO DE APARELHOS TELEFÔNICOS E DE OUTROS EQUIPAMENTOS DE COMUNICAÇÃO, PEÇAS E ACESSÓRIOS",
	"2640000":
		"FABRICAÇÃO DE APARELHOS DE RECEPÇÃO, REPRODUÇÃO, GRAVAÇÃO E AMPLIFICAÇÃO DE ÁUDIO E VÍDEO",
	"2651500": "FABRICAÇÃO DE APARELHOS E EQUIPAMENTOS DE MEDIDA, TESTE E CONTROLE",
	"2652300": "FABRICAÇÃO DE CRONÔMETROS E RELÓGIOS",
	"2660400":
		"FABRICAÇÃO DE APARELHOS ELETROMÉDICOS E ELETROTERAPÊUTICOS E EQUIPAMENTOS DE IRRADIAÇÃO",
	"2670101": "FABRICAÇÃO DE EQUIPAMENTOS E INSTRUMENTOS ÓPTICOS, PEÇAS E ACESSÓRIOS",
	"2670102": "FABRICAÇÃO DE APARELHOS FOTOGRÁFICOS E CINEMATOGRÁFICOS, PEÇAS E ACESSÓRIOS",
	"2680900": "FABRICAÇÃO DE MÍDIAS VIRGENS, MAGNÉTICAS E ÓPTICAS",
	"2710401": "FABRICAÇÃO DE GERADORES DE CORRENTE CONTÍNUA E ALTERNADA, PEÇAS E ACESSÓRIOS",
	"2710402":
		"FABRICAÇÃO DE TRANSFORMADORES, INDUTORES, CONVERSORES, SINCRONIZADORES E SEMELHANTES, PEÇAS E ACESSÓRIOS",
	"2710403": "FABRICAÇÃO DE MOTORES ELÉTRICOS, PEÇAS E ACESSÓRIOS",
	"2721000":
		"FABRICAÇÃO DE PILHAS, BATERIAS E ACUMULADORES ELÉTRICOS, EXCETO PARA VEÍCULOS AUTOMOTORES",
	"2722801": "FABRICAÇÃO DE BATERIAS E ACUMULADORES PARA VEÍCULOS AUTOMOTORES",
	"2722802": "RECONDICIONAMENTO DE BATERIAS E ACUMULADORES PARA VEÍCULOS AUTOMOTORES",
	"2731700":
		"FABRICAÇÃO DE APARELHOS E EQUIPAMENTOS PARA DISTRIBUIÇÃO E CONTROLE DE ENERGIA ELÉTRICA",
	"2732500": "FABRICAÇÃO DE MATERIAL ELÉTRICO PARA INSTALAÇÕES EM CIRCUITO DE CONSUMO",
	"2733300": "FABRICAÇÃO DE FIOS, CABOS E CONDUTORES ELÉTRICOS ISOLADOS",
	"2740601": "FABRICAÇÃO DE LÂMPADAS",
	"2740602": "FABRICAÇÃO DE LUMINÁRIAS E OUTROS EQUIPAMENTOS DE ILUMINAÇÃO",
	"2751100":
		"FABRICAÇÃO DE FOGÕES, REFRIGERADORES E MÁQUINAS DE LAVAR E SECAR PARA USO DOMÉSTICO, PEÇAS E ACESSÓRIOS",
	"2759701": "FABRICAÇÃO DE APARELHOS ELÉTRICOS DE USO PESSOAL, PEÇAS E ACESSÓRIOS",
	"2759799":
		"FABRICAÇÃO DE OUTROS APARELHOS ELETRODOMÉSTICOS NÃO ESPECIFICADOS ANTERIORMENTE, PEÇAS E ACESSÓRIOS",
	"2790201":
		"FABRICAÇÃO DE ELETRODOS, CONTATOS E OUTROS ARTIGOS DE CARVÃO E GRAFITA PARA USO ELÉTRICO, ELETROÍMÃS E ISOLADORES",
	"2790202": "FABRICAÇÃO DE EQUIPAMENTOS PARA SINALIZAÇÃO E ALARME",
	"2790299":
		"FABRICAÇÃO DE OUTROS EQUIPAMENTOS E APARELHOS ELÉTRICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"2811900":
		"FABRICAÇÃO DE MOTORES E TURBINAS, PEÇAS E ACESSÓRIOS, EXCETO PARA AVIÕES E VEÍCULOS RODOVIÁRIOS",
	"2812700":
		"FABRICAÇÃO DE EQUIPAMENTOS HIDRÁULICOS E PNEUMÁTICOS, PEÇAS E ACESSÓRIOS, EXCETO VÁLVULAS",
	"2813500": "FABRICAÇÃO DE VÁLVULAS, REGISTROS E DISPOSITIVOS SEMELHANTES, PEÇAS E ACESSÓRIOS",
	"2814301": "FABRICAÇÃO DE COMPRESSORES PARA USO INDUSTRIAL, PEÇAS E ACESSÓRIOS",
	"2814302": "FABRICAÇÃO DE COMPRESSORES PARA USO NÃO INDUSTRIAL, PEÇAS E ACESSÓRIOS",
	"2815101": "FABRICAÇÃO DE ROLAMENTOS PARA FINS INDUSTRIAIS",
	"2815102": "FABRICAÇÃO DE EQUIPAMENTOS DE TRANSMISSÃO PARA FINS INDUSTRIAIS, EXCETO ROLAMENTOS",
	"2821601":
		"FABRICAÇÃO DE FORNOS INDUSTRIAIS, APARELHOS E EQUIPAMENTOS NÃO ELÉTRICOS PARA INSTALAÇÕES TÉRMICAS, PEÇAS E ACESSÓRIOS",
	"2821602": "FABRICAÇÃO DE ESTUFAS E FORNOS ELÉTRICOS PARA FINS INDUSTRIAIS, PEÇAS E ACESSÓRIOS",
	"2822401":
		"FABRICAÇÃO DE MÁQUINAS, EQUIPAMENTOS E APARELHOS PARA TRANSPORTE E ELEVAÇÃO DE PESSOAS, PEÇAS E ACESSÓRIOS",
	"2822402":
		"FABRICAÇÃO DE MÁQUINAS, EQUIPAMENTOS E APARELHOS PARA TRANSPORTE E ELEVAÇÃO DE CARGAS, PEÇAS E ACESSÓRIOS",
	"2823200":
		"FABRICAÇÃO DE MÁQUINAS E APARELHOS DE REFRIGERAÇÃO E VENTILAÇÃO PARA USO INDUSTRIAL E COMERCIAL, PEÇAS E ACESSÓRIOS",
	"2824101": "FABRICAÇÃO DE APARELHOS E EQUIPAMENTOS DE AR CONDICIONADO PARA USO INDUSTRIAL",
	"2824102": "FABRICAÇÃO DE APARELHOS E EQUIPAMENTOS DE AR CONDICIONADO PARA USO NÃO INDUSTRIAL",
	"2825900":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA SANEAMENTO BÁSICO E AMBIENTAL, PEÇAS E ACESSÓRIOS",
	"2829101":
		"FABRICAÇÃO DE MÁQUINAS DE ESCREVER, CALCULAR E OUTROS EQUIPAMENTOS NÃO ELETRÔNICOS PARA ESCRITÓRIO, PEÇAS E ACESSÓRIOS",
	"2829199":
		"FABRICAÇÃO DE OUTRAS MÁQUINAS E EQUIPAMENTOS DE USO GERAL NÃO ESPECIFICADOS ANTERIORMENTE, PEÇAS E ACESSÓRIOS",
	"2831300": "FABRICAÇÃO DE TRATORES AGRÍCOLAS, PEÇAS E ACESSÓRIOS",
	"2832100": "FABRICAÇÃO DE EQUIPAMENTOS PARA IRRIGAÇÃO AGRÍCOLA, PEÇAS E ACESSÓRIOS",
	"2833000":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA A AGRICULTURA E PECUÁRIA, PEÇAS E ACESSÓRIOS, EXCETO PARA IRRIGAÇÃO",
	"2840200": "FABRICAÇÃO DE MÁQUINAS FERRAMENTA, PEÇAS E ACESSÓRIOS",
	"2851800":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA A PROSPECÇÃO E EXTRAÇÃO DE PETRÓLEO, PEÇAS E ACESSÓRIOS",
	"2852600":
		"FABRICAÇÃO DE OUTRAS MÁQUINAS E EQUIPAMENTOS PARA USO NA EXTRAÇÃO MINERAL, PEÇAS E ACESSÓRIOS, EXCETO NA EXTRAÇÃO DE PETRÓLEO",
	"2853400": "FABRICAÇÃO DE TRATORES, PEÇAS E ACESSÓRIOS, EXCETO AGRÍCOLAS",
	"2854200":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA TERRAPLENAGEM, PAVIMENTAÇÃO E CONSTRUÇÃO, PEÇAS E ACESSÓRIOS, EXCETO TRATORES",
	"2861500":
		"FABRICAÇÃO DE MÁQUINAS PARA A INDÚSTRIA METALÚRGICA, PEÇAS E ACESSÓRIOS, EXCETO MÁQUINAS FERRAMENTA",
	"2862300":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA AS INDÚSTRIAS DE ALIMENTOS, BEBIDAS E FUMO, PEÇAS E ACESSÓRIOS",
	"2863100": "FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA A INDÚSTRIA TÊXTIL, PEÇAS E ACESSÓRIOS",
	"2864000":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA AS INDÚSTRIAS DO VESTUÁRIO, DO COURO E DE CALÇADOS, PEÇAS E ACESSÓRIOS",
	"2865800":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA AS INDÚSTRIAS DE CELULOSE, PAPEL E PAPELÃO E ARTEFATOS, PEÇAS E ACESSÓRIOS",
	"2866600":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA A INDÚSTRIA DO PLÁSTICO, PEÇAS E ACESSÓRIOS",
	"2869100":
		"FABRICAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA USO INDUSTRIAL ESPECÍFICO NÃO ESPECIFICADOS ANTERIORMENTE, PEÇAS E ACESSÓRIOS",
	"2910701": "FABRICAÇÃO DE AUTOMÓVEIS, CAMIONETAS E UTILITÁRIOS",
	"2910702": "FABRICAÇÃO DE CHASSIS COM MOTOR PARA AUTOMÓVEIS, CAMIONETAS E UTILITÁRIOS",
	"2910703": "FABRICAÇÃO DE MOTORES PARA AUTOMÓVEIS, CAMIONETAS E UTILITÁRIOS",
	"2920401": "FABRICAÇÃO DE CAMINHÕES E ÔNIBUS",
	"2920402": "FABRICAÇÃO DE MOTORES PARA CAMINHÕES E ÔNIBUS",
	"2930101": "FABRICAÇÃO DE CABINES, CARROCERIAS E REBOQUES PARA CAMINHÕES",
	"2930102": "FABRICAÇÃO DE CARROCERIAS PARA ÔNIBUS",
	"2930103":
		"FABRICAÇÃO DE CABINES, CARROCERIAS E REBOQUES PARA OUTROS VEÍCULOS AUTOMOTORES, EXCETO CAMINHÕES E ÔNIBUS",
	"2941700": "FABRICAÇÃO DE PEÇAS E ACESSÓRIOS PARA O SISTEMA MOTOR DE VEÍCULOS AUTOMOTORES",
	"2942500":
		"FABRICAÇÃO DE PEÇAS E ACESSÓRIOS PARA OS SISTEMAS DE MARCHA E TRANSMISSÃO DE VEÍCULOS AUTOMOTORES",
	"2943300": "FABRICAÇÃO DE PEÇAS E ACESSÓRIOS PARA O SISTEMA DE FREIOS DE VEÍCULOS AUTOMOTORES",
	"2944100":
		"FABRICAÇÃO DE PEÇAS E ACESSÓRIOS PARA O SISTEMA DE DIREÇÃO E SUSPENSÃO DE VEÍCULOS AUTOMOTORES",
	"2945000":
		"FABRICAÇÃO DE MATERIAL ELÉTRICO E ELETRÔNICO PARA VEÍCULOS AUTOMOTORES, EXCETO BATERIAS",
	"2949201": "FABRICAÇÃO DE BANCOS E ESTOFADOS PARA VEÍCULOS AUTOMOTORES",
	"2949299":
		"FABRICAÇÃO DE OUTRAS PEÇAS E ACESSÓRIOS PARA VEÍCULOS AUTOMOTORES NÃO ESPECIFICADAS ANTERIORMENTE",
	"2950600": "RECONDICIONAMENTO E RECUPERAÇÃO DE MOTORES PARA VEÍCULOS AUTOMOTORES",
	"3011301": "CONSTRUÇÃO DE EMBARCAÇÕES DE GRANDE PORTE",
	"3011302":
		"CONSTRUÇÃO DE EMBARCAÇÕES PARA USO COMERCIAL E PARA USOS ESPECIAIS, EXCETO DE GRANDE PORTE",
	"3012100": "CONSTRUÇÃO DE EMBARCAÇÕES PARA ESPORTE E LAZER",
	"3031800": "FABRICAÇÃO DE LOCOMOTIVAS, VAGÕES E OUTROS MATERIAIS RODANTES",
	"3032600": "FABRICAÇÃO DE PEÇAS E ACESSÓRIOS PARA VEÍCULOS FERROVIÁRIOS",
	"3041500": "FABRICAÇÃO DE AERONAVES",
	"3042300": "FABRICAÇÃO DE TURBINAS, MOTORES E OUTROS COMPONENTES E PEÇAS PARA AERONAVES",
	"3050400": "FABRICAÇÃO DE VEÍCULOS MILITARES DE COMBATE",
	"3091101": "FABRICAÇÃO DE MOTOCICLETAS",
	"3091102": "FABRICAÇÃO DE PEÇAS E ACESSÓRIOS PARA MOTOCICLETAS",
	"3092000": "FABRICAÇÃO DE BICICLETAS E TRICICLOS NÃO MOTORIZADOS, PEÇAS E ACESSÓRIOS",
	"3099700": "FABRICAÇÃO DE EQUIPAMENTOS DE TRANSPORTE NÃO ESPECIFICADOS ANTERIORMENTE",
	"3101200": "FABRICAÇÃO DE MÓVEIS COM PREDOMINÂNCIA DE MADEIRA",
	"3102100": "FABRICAÇÃO DE MÓVEIS COM PREDOMINÂNCIA DE METAL",
	"3103900": "FABRICAÇÃO DE MÓVEIS DE OUTROS MATERIAIS, EXCETO MADEIRA E METAL",
	"3104700": "FABRICAÇÃO DE COLCHÕES",
	"3211601": "LAPIDAÇÃO DE GEMAS",
	"3211602": "FABRICAÇÃO DE ARTEFATOS DE JOALHERIA E OURIVESARIA",
	"3211603": "CUNHAGEM DE MOEDAS E MEDALHAS",
	"3212400": "FABRICAÇÃO DE BIJUTERIAS E ARTEFATOS SEMELHANTES",
	"3220500": "FABRICAÇÃO DE INSTRUMENTOS MUSICAIS, PEÇAS E ACESSÓRIOS",
	"3230200": "FABRICAÇÃO DE ARTEFATOS PARA PESCA E ESPORTE",
	"3240001": "FABRICAÇÃO DE JOGOS ELETRÔNICOS",
	"3240002": "FABRICAÇÃO DE MESAS DE BILHAR, DE SINUCA E ACESSÓRIOS NÃO ASSOCIADA À LOCAÇÃO",
	"3240003": "FABRICAÇÃO DE MESAS DE BILHAR, DE SINUCA E ACESSÓRIOS ASSOCIADA À LOCAÇÃO",
	"3240099": "FABRICAÇÃO DE OUTROS BRINQUEDOS E JOGOS RECREATIVOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3250701":
		"FABRICAÇÃO DE INSTRUMENTOS NÃO ELETRÔNICOS E UTENSÍLIOS PARA USO MÉDICO, CIRÚRGICO, ODONTOLÓGICO E DE LABORATÓRIO",
	"3250702": "FABRICAÇÃO DE MOBILIÁRIO PARA USO MÉDICO, CIRÚRGICO, ODONTOLÓGICO E DE LABORATÓRIO",
	"3250703":
		"FABRICAÇÃO DE APARELHOS E UTENSÍLIOS PARA CORREÇÃO DE DEFEITOS FÍSICOS E APARELHOS ORTOPÉDICOS EM GERAL SOB ENCOMENDA",
	"3250704":
		"FABRICAÇÃO DE APARELHOS E UTENSÍLIOS PARA CORREÇÃO DE DEFEITOS FÍSICOS E APARELHOS ORTOPÉDICOS EM GERAL, EXCETO SOB ENCOMENDA",
	"3250705": "FABRICAÇÃO DE MATERIAIS PARA MEDICINA E ODONTOLOGIA",
	"3250706": "SERVIÇOS DE PRÓTESE DENTÁRIA",
	"3250707": "FABRICAÇÃO DE ARTIGOS ÓPTICOS",
	"3250709": "SERVIÇO DE LABORATÓRIO ÓPTICO",
	"3291400": "FABRICAÇÃO DE ESCOVAS, PINCÉIS E VASSOURAS",
	"3292201": "FABRICAÇÃO DE ROUPAS DE PROTEÇÃO E SEGURANÇA E RESISTENTES A FOGO",
	"3292202": "FABRICAÇÃO DE EQUIPAMENTOS E ACESSÓRIOS PARA SEGURANÇA PESSOAL E PROFISSIONAL",
	"3299001": "FABRICAÇÃO DE GUARDA CHUVAS E SIMILARES",
	"3299002": "FABRICAÇÃO DE CANETAS, LÁPIS E OUTROS ARTIGOS PARA ESCRITÓRIO",
	"3299003": "FABRICAÇÃO DE LETRAS, LETREIROS E PLACAS DE QUALQUER MATERIAL, EXCETO LUMINOSOS",
	"3299004": "FABRICAÇÃO DE PAINÉIS E LETREIROS LUMINOSOS",
	"3299005": "FABRICAÇÃO DE AVIAMENTOS PARA COSTURA",
	"3299006": "FABRICAÇÃO DE VELAS, INCLUSIVE DECORATIVAS",
	"3299099": "FABRICAÇÃO DE PRODUTOS DIVERSOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3311200":
		"MANUTENÇÃO E REPARAÇÃO DE TANQUES, RESERVATÓRIOS METÁLICOS E CALDEIRAS, EXCETO PARA VEÍCULOS",
	"3312102": "MANUTENÇÃO E REPARAÇÃO DE APARELHOS E INSTRUMENTOS DE MEDIDA, TESTE E CONTROLE",
	"3312103":
		"MANUTENÇÃO E REPARAÇÃO DE APARELHOS ELETROMÉDICOS E ELETROTERAPÊUTICOS E EQUIPAMENTOS DE IRRADIAÇÃO",
	"3312104": "MANUTENÇÃO E REPARAÇÃO DE EQUIPAMENTOS E INSTRUMENTOS ÓPTICOS",
	"3313901": "MANUTENÇÃO E REPARAÇÃO DE GERADORES, TRANSFORMADORES E MOTORES ELÉTRICOS",
	"3313902": "MANUTENÇÃO E REPARAÇÃO DE BATERIAS E ACUMULADORES ELÉTRICOS, EXCETO PARA VEÍCULOS",
	"3313999":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS, APARELHOS E MATERIAIS ELÉTRICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3314701": "MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS MOTRIZES NÃO ELÉTRICAS",
	"3314702": "MANUTENÇÃO E REPARAÇÃO DE EQUIPAMENTOS HIDRÁULICOS E PNEUMÁTICOS, EXCETO VÁLVULAS",
	"3314703": "MANUTENÇÃO E REPARAÇÃO DE VÁLVULAS INDUSTRIAIS",
	"3314704": "MANUTENÇÃO E REPARAÇÃO DE COMPRESSORES",
	"3314705": "MANUTENÇÃO E REPARAÇÃO DE EQUIPAMENTOS DE TRANSMISSÃO PARA FINS INDUSTRIAIS",
	"3314706":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS, APARELHOS E EQUIPAMENTOS PARA INSTALAÇÕES TÉRMICAS",
	"3314707":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E APARELHOS DE REFRIGERAÇÃO E VENTILAÇÃO PARA USO INDUSTRIAL E COMERCIAL",
	"3314708":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS, EQUIPAMENTOS E APARELHOS PARA TRANSPORTE E ELEVAÇÃO DE CARGAS",
	"3314709":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS DE ESCREVER, CALCULAR E DE OUTROS EQUIPAMENTOS NÃO ELETRÔNICOS PARA ESCRITÓRIO",
	"3314710":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA USO GERAL NÃO ESPECIFICADOS ANTERIORMENTE",
	"3314711": "MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA AGRICULTURA E PECUÁRIA",
	"3314712": "MANUTENÇÃO E REPARAÇÃO DE TRATORES AGRÍCOLAS",
	"3314713": "MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS FERRAMENTA",
	"3314714":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA A PROSPECÇÃO E EXTRAÇÃO DE PETRÓLEO",
	"3314715":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA USO NA EXTRAÇÃO MINERAL, EXCETO NA EXTRAÇÃO DE PETRÓLEO",
	"3314716": "MANUTENÇÃO E REPARAÇÃO DE TRATORES, EXCETO AGRÍCOLAS",
	"3314717":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS DE TERRAPLENAGEM, PAVIMENTAÇÃO E CONSTRUÇÃO, EXCETO TRATORES",
	"3314718":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS PARA A INDÚSTRIA METALÚRGICA, EXCETO MÁQUINAS FERRAMENTA",
	"3314719":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA AS INDÚSTRIAS DE ALIMENTOS, BEBIDAS E FUMO",
	"3314720":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E EQUIPAMENTOS PARA A INDÚSTRIA TÊXTIL, DO VESTUÁRIO, DO COURO E CALÇADOS",
	"3314721":
		"MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E APARELHOS PARA A INDÚSTRIA DE CELULOSE, PAPEL E PAPELÃO E ARTEFATOS",
	"3314722": "MANUTENÇÃO E REPARAÇÃO DE MÁQUINAS E APARELHOS PARA A INDÚSTRIA DO PLÁSTICO",
	"3314799":
		"MANUTENÇÃO E REPARAÇÃO DE OUTRAS MÁQUINAS E EQUIPAMENTOS PARA USOS INDUSTRIAIS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3315500": "MANUTENÇÃO E REPARAÇÃO DE VEÍCULOS FERROVIÁRIOS",
	"3316301": "MANUTENÇÃO E REPARAÇÃO DE AERONAVES, EXCETO A MANUTENÇÃO NA PISTA",
	"3316302": "MANUTENÇÃO DE AERONAVES NA PISTA",
	"3317101": "MANUTENÇÃO E REPARAÇÃO DE EMBARCAÇÕES E ESTRUTURAS FLUTUANTES",
	"3317102": "MANUTENÇÃO E REPARAÇÃO DE EMBARCAÇÕES PARA ESPORTE E LAZER",
	"3319800": "MANUTENÇÃO E REPARAÇÃO DE EQUIPAMENTOS E PRODUTOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3321000": "INSTALAÇÃO DE MÁQUINAS E EQUIPAMENTOS INDUSTRIAIS",
	"3329501": "SERVIÇOS DE MONTAGEM DE MÓVEIS DE QUALQUER MATERIAL",
	"3329599": "INSTALAÇÃO DE OUTROS EQUIPAMENTOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3511501": "GERAÇÃO DE ENERGIA ELÉTRICA",
	"3511502":
		"ATIVIDADES DE COORDENAÇÃO E CONTROLE DA OPERAÇÃO DA GERAÇÃO E TRANSMISSÃO DE ENERGIA ELÉTRICA",
	"3512300": "TRANSMISSÃO DE ENERGIA ELÉTRICA",
	"3513100": "COMÉRCIO ATACADISTA DE ENERGIA ELÉTRICA",
	"3514000": "DISTRIBUIÇÃO DE ENERGIA ELÉTRICA",
	"3520401": "PRODUÇÃO DE GÁS; PROCESSAMENTO DE GÁS NATURAL",
	"3520402": "DISTRIBUIÇÃO DE COMBUSTÍVEIS GASOSOS POR REDES URBANAS",
	"3530100": "PRODUÇÃO E DISTRIBUIÇÃO DE VAPOR, ÁGUA QUENTE E AR CONDICIONADO",
	"3600601": "CAPTAÇÃO, TRATAMENTO E DISTRIBUIÇÃO DE ÁGUA",
	"3600602": "DISTRIBUIÇÃO DE ÁGUA POR CAMINHÕES",
	"3701100": "GESTÃO DE REDES DE ESGOTO",
	"3702900": "ATIVIDADES RELACIONADAS A ESGOTO, EXCETO A GESTÃO DE REDES",
	"3811400": "COLETA DE RESÍDUOS NÃO PERIGOSOS",
	"3812200": "COLETA DE RESÍDUOS PERIGOSOS",
	"3821100": "TRATAMENTO E DISPOSIÇÃO DE RESÍDUOS NÃO PERIGOSOS",
	"3822000": "TRATAMENTO E DISPOSIÇÃO DE RESÍDUOS PERIGOSOS",
	"3831901": "RECUPERAÇÃO DE SUCATAS DE ALUMÍNIO",
	"3831999": "RECUPERAÇÃO DE MATERIAIS METÁLICOS, EXCETO ALUMÍNIO",
	"3832700": "RECUPERAÇÃO DE MATERIAIS PLÁSTICOS",
	"3839401": "USINAS DE COMPOSTAGEM",
	"3839499": "RECUPERAÇÃO DE MATERIAIS NÃO ESPECIFICADOS ANTERIORMENTE",
	"3900500": "DESCONTAMINAÇÃO E OUTROS SERVIÇOS DE GESTÃO DE RESÍDUOS",
	"4110700": "INCORPORAÇÃO DE EMPREENDIMENTOS IMOBILIÁRIOS",
	"4120400": "CONSTRUÇÃO DE EDIFÍCIOS",
	"4211101": "CONSTRUÇÃO DE RODOVIAS E FERROVIAS",
	"4211102": "PINTURA PARA SINALIZAÇÃO EM PISTAS RODOVIÁRIAS E AEROPORTOS",
	"4212000": "CONSTRUÇÃO DE OBRAS DE ARTE ESPECIAIS",
	"4213800": "OBRAS DE URBANIZAÇÃO - RUAS, PRAÇAS E CALÇADAS",
	"4221901": "CONSTRUÇÃO DE BARRAGENS E REPRESAS PARA GERAÇÃO DE ENERGIA ELÉTRICA",
	"4221902": "CONSTRUÇÃO DE ESTAÇÕES E REDES DE DISTRIBUIÇÃO DE ENERGIA ELÉTRICA",
	"4221903": "MANUTENÇÃO DE REDES DE DISTRIBUIÇÃO DE ENERGIA ELÉTRICA",
	"4221904": "CONSTRUÇÃO DE ESTAÇÕES E REDES DE TELECOMUNICAÇÕES",
	"4221905": "MANUTENÇÃO DE ESTAÇÕES E REDES DE TELECOMUNICAÇÕES",
	"4222701":
		"CONSTRUÇÃO DE REDES DE ABASTECIMENTO DE ÁGUA, COLETA DE ESGOTO E CONSTRUÇÕES CORRELATAS, EXCETO OBRAS DE IRRIGAÇÃO",
	"4222702": "OBRAS DE IRRIGAÇÃO",
	"4223500": "CONSTRUÇÃO DE REDES DE TRANSPORTES POR DUTOS, EXCETO PARA ÁGUA E ESGOTO",
	"4291000": "OBRAS PORTUÁRIAS, MARÍTIMAS E FLUVIAIS",
	"4292801": "MONTAGEM DE ESTRUTURAS METÁLICAS",
	"4292802": "OBRAS DE MONTAGEM INDUSTRIAL",
	"4299501": "CONSTRUÇÃO DE INSTALAÇÕES ESPORTIVAS E RECREATIVAS",
	"4299599": "OUTRAS OBRAS DE ENGENHARIA CIVIL NÃO ESPECIFICADAS ANTERIORMENTE",
	"4311801": "DEMOLIÇÃO DE EDIFÍCIOS E OUTRAS ESTRUTURAS",
	"4311802": "PREPARAÇÃO DE CANTEIRO E LIMPEZA DE TERRENO",
	"4312600": "PERFURAÇÕES E SONDAGENS",
	"4313400": "OBRAS DE TERRAPLENAGEM",
	"4319300": "SERVIÇOS DE PREPARAÇÃO DO TERRENO NÃO ESPECIFICADOS ANTERIORMENTE",
	"4321500": "INSTALAÇÃO E MANUTENÇÃO ELÉTRICA",
	"4322301": "INSTALAÇÕES HIDRÁULICAS, SANITÁRIAS E DE GÁS",
	"4322302":
		"INSTALAÇÃO E MANUTENÇÃO DE SISTEMAS CENTRAIS DE AR CONDICIONADO, DE VENTILAÇÃO E REFRIGERAÇÃO",
	"4322303": "INSTALAÇÕES DE SISTEMA DE PREVENÇÃO CONTRA INCÊNDIO",
	"4329101": "INSTALAÇÃO DE PAINÉIS PUBLICITÁRIOS",
	"4329102": "INSTALAÇÃO DE EQUIPAMENTOS PARA ORIENTAÇÃO À NAVEGAÇÃO MARÍTIMA FLUVIAL E LACUSTRE",
	"4329103": "INSTALAÇÃO, MANUTENÇÃO E REPARAÇÃO DE ELEVADORES, ESCADAS E ESTEIRAS ROLANTES",
	"4329104":
		"MONTAGEM E INSTALAÇÃO DE SISTEMAS E EQUIPAMENTOS DE ILUMINAÇÃO E SINALIZAÇÃO EM VIAS PÚBLICAS, PORTOS E AEROPORTOS",
	"4329105": "TRATAMENTOS TÉRMICOS, ACÚSTICOS OU DE VIBRAÇÃO",
	"4329199": "OUTRAS OBRAS DE INSTALAÇÕES EM CONSTRUÇÕES NÃO ESPECIFICADAS ANTERIORMENTE",
	"4330401": "IMPERMEABILIZAÇÃO EM OBRAS DE ENGENHARIA CIVIL",
	"4330402":
		"INSTALAÇÃO DE PORTAS, JANELAS, TETOS, DIVISÓRIAS E ARMÁRIOS EMBUTIDOS DE QUALQUER MATERIAL",
	"4330403": "OBRAS DE ACABAMENTO EM GESSO E ESTUQUE",
	"4330404": "SERVIÇOS DE PINTURA DE EDIFÍCIOS EM GERAL",
	"4330405": "APLICAÇÃO DE REVESTIMENTOS E DE RESINAS EM INTERIORES E EXTERIORES",
	"4330499": "OUTRAS OBRAS DE ACABAMENTO DA CONSTRUÇÃO",
	"4391600": "OBRAS DE FUNDAÇÕES",
	"4399101": "ADMINISTRAÇÃO DE OBRAS",
	"4399102": "MONTAGEM E DESMONTAGEM DE ANDAIMES E OUTRAS ESTRUTURAS TEMPORÁRIAS",
	"4399103": "OBRAS DE ALVENARIA",
	"4399104":
		"SERVIÇOS DE OPERAÇÃO E FORNECIMENTO DE EQUIPAMENTOS PARA TRANSPORTE E ELEVAÇÃO DE CARGAS E PESSOAS PARA USO EM OBRAS",
	"4399105": "PERFURAÇÃO E CONSTRUÇÃO DE POÇOS DE ÁGUA",
	"4399199": "SERVIÇOS ESPECIALIZADOS PARA CONSTRUÇÃO NÃO ESPECIFICADOS ANTERIORMENTE",
	"4511101": "COMÉRCIO A VAREJO DE AUTOMÓVEIS, CAMIONETAS E UTILITÁRIOS NOVOS",
	"4511102": "COMÉRCIO A VAREJO DE AUTOMÓVEIS, CAMIONETAS E UTILITÁRIOS USADOS",
	"4511103": "COMÉRCIO POR ATACADO DE AUTOMÓVEIS, CAMIONETAS E UTILITÁRIOS NOVOS E USADOS",
	"4511104": "COMÉRCIO POR ATACADO DE CAMINHÕES NOVOS E USADOS",
	"4511105": "COMÉRCIO POR ATACADO DE REBOQUES E SEMI REBOQUES NOVOS E USADOS",
	"4511106": "COMÉRCIO POR ATACADO DE ÔNIBUS E MICROÔNIBUS NOVOS E USADOS",
	"4512901": "REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE VEÍCULOS AUTOMOTORES",
	"4512902": "COMÉRCIO SOB CONSIGNAÇÃO DE VEÍCULOS AUTOMOTORES",
	"4520001": "SERVIÇOS DE MANUTENÇÃO E REPARAÇÃO MECÂNICA DE VEÍCULOS AUTOMOTORES",
	"4520002": "SERVIÇOS DE LANTERNAGEM OU FUNILARIA E PINTURA DE VEÍCULOS AUTOMOTORES",
	"4520003": "SERVIÇOS DE MANUTENÇÃO E REPARAÇÃO ELÉTRICA DE VEÍCULOS AUTOMOTORES",
	"4520004": "SERVIÇOS DE ALINHAMENTO E BALANCEAMENTO DE VEÍCULOS AUTOMOTORES",
	"4520005": "SERVIÇOS DE LAVAGEM, LUBRIFICAÇÃO E POLIMENTO DE VEÍCULOS AUTOMOTORES",
	"4520006": "SERVIÇOS DE BORRACHARIA PARA VEÍCULOS AUTOMOTORES",
	"4520007":
		"SERVIÇOS DE INSTALAÇÃO, MANUTENÇÃO E REPARAÇÃO DE ACESSÓRIOS PARA VEÍCULOS AUTOMOTORES",
	"4520008": "SERVIÇOS DE CAPOTARIA",
	"4530701": "COMÉRCIO POR ATACADO DE PEÇAS E ACESSÓRIOS NOVOS PARA VEÍCULOS AUTOMOTORES",
	"4530702": "COMÉRCIO POR ATACADO DE PNEUMÁTICOS E CÂMARAS DE AR",
	"4530703": "COMÉRCIO A VAREJO DE PEÇAS E ACESSÓRIOS NOVOS PARA VEÍCULOS AUTOMOTORES",
	"4530704": "COMÉRCIO A VAREJO DE PEÇAS E ACESSÓRIOS USADOS PARA VEÍCULOS AUTOMOTORES",
	"4530705": "COMÉRCIO A VAREJO DE PNEUMÁTICOS E CÂMARAS DE AR",
	"4530706":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE PEÇAS E ACESSÓRIOS NOVOS E USADOS PARA VEÍCULOS AUTOMOTORES",
	"4541201": "COMÉRCIO POR ATACADO DE MOTOCICLETAS E MOTONETAS",
	"4541202": "COMÉRCIO POR ATACADO DE PEÇAS E ACESSÓRIOS PARA MOTOCICLETAS E MOTONETAS",
	"4541203": "COMÉRCIO A VAREJO DE MOTOCICLETAS E MOTONETAS NOVAS",
	"4541204": "COMÉRCIO A VAREJO DE MOTOCICLETAS E MOTONETAS USADAS",
	"4541206": "COMÉRCIO A VAREJO DE PEÇAS E ACESSÓRIOS NOVOS PARA MOTOCICLETAS E MOTONETAS",
	"4541207": "COMÉRCIO A VAREJO DE PEÇAS E ACESSÓRIOS USADOS PARA MOTOCICLETAS E MOTONETAS",
	"4542101":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE MOTOCICLETAS E MOTONETAS, PEÇAS E ACESSÓRIOS",
	"4542102": "COMÉRCIO SOB CONSIGNAÇÃO DE MOTOCICLETAS E MOTONETAS",
	"4543900": "MANUTENÇÃO E REPARAÇÃO DE MOTOCICLETAS E MOTONETAS",
	"4611700":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE MATÉRIAS PRIMAS AGRÍCOLAS E ANIMAIS VIVOS",
	"4612500":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE COMBUSTÍVEIS, MINERAIS, PRODUTOS SIDERÚRGICOS E QUÍMICOS",
	"4613300":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE MADEIRA, MATERIAL DE CONSTRUÇÃO E FERRAGENS",
	"4614100":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE MÁQUINAS, EQUIPAMENTOS, EMBARCAÇÕES E AERONAVES",
	"4615000":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE ELETRODOMÉSTICOS, MÓVEIS E ARTIGOS DE USO DOMÉSTICO",
	"4616800":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE TÊXTEIS, VESTUÁRIO, CALÇADOS E ARTIGOS DE VIAGEM",
	"4617600":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE PRODUTOS ALIMENTÍCIOS, BEBIDAS E FUMO",
	"4618401":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE MEDICAMENTOS, COSMÉTICOS E PRODUTOS DE PERFUMARIA",
	"4618402":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE INSTRUMENTOS E MATERIAIS ODONTO MÉDICO HOSPITALARES",
	"4618403":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE JORNAIS, REVISTAS E OUTRAS PUBLICAÇÕES",
	"4618499":
		"OUTROS REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO ESPECIALIZADO EM PRODUTOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4619200":
		"REPRESENTANTES COMERCIAIS E AGENTES DO COMÉRCIO DE MERCADORIAS EM GERAL NÃO ESPECIALIZADO",
	"4621400": "COMÉRCIO ATACADISTA DE CAFÉ EM GRÃO",
	"4622200": "COMÉRCIO ATACADISTA DE SOJA",
	"4623101": "COMÉRCIO ATACADISTA DE ANIMAIS VIVOS",
	"4623102":
		"COMÉRCIO ATACADISTA DE COUROS, LÃS, PELES E OUTROS SUBPRODUTOS NÃO COMESTÍVEIS DE ORIGEM ANIMAL",
	"4623103": "COMÉRCIO ATACADISTA DE ALGODÃO",
	"4623104": "COMÉRCIO ATACADISTA DE FUMO EM FOLHA NÃO BENEFICIADO",
	"4623105": "COMÉRCIO ATACADISTA DE CACAU",
	"4623106": "COMÉRCIO ATACADISTA DE SEMENTES, FLORES, PLANTAS E GRAMAS",
	"4623107": "COMÉRCIO ATACADISTA DE SISAL",
	"4623108":
		"COMÉRCIO ATACADISTA DE MATÉRIAS PRIMAS AGRÍCOLAS COM ATIVIDADE DE FRACIONAMENTO E ACONDICIONAMENTO ASSOCIADA",
	"4623109": "COMÉRCIO ATACADISTA DE ALIMENTOS PARA ANIMAIS",
	"4623199": "COMÉRCIO ATACADISTA DE MATÉRIAS PRIMAS AGRÍCOLAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"4631100": "COMÉRCIO ATACADISTA DE LEITE E LATICÍNIOS",
	"4632001": "COMÉRCIO ATACADISTA DE CEREAIS E LEGUMINOSAS BENEFICIADOS",
	"4632002": "COMÉRCIO ATACADISTA DE FARINHAS, AMIDOS E FÉCULAS",
	"4632003":
		"COMÉRCIO ATACADISTA DE CEREAIS E LEGUMINOSAS BENEFICIADOS, FARINHAS, AMIDOS E FÉCULAS, COM ATIVIDADE DE FRACIONAMENTO E ACONDICIONAMENTO ASSOCIADA",
	"4633801":
		"COMÉRCIO ATACADISTA DE FRUTAS, VERDURAS, RAÍZES, TUBÉRCULOS, HORTALIÇAS E LEGUMES FRESCOS",
	"4633802": "COMÉRCIO ATACADISTA DE AVES VIVAS E OVOS",
	"4633803": "COMÉRCIO ATACADISTA DE COELHOS E OUTROS PEQUENOS ANIMAIS VIVOS PARA ALIMENTAÇÃO",
	"4634601": "COMÉRCIO ATACADISTA DE CARNES BOVINAS E SUÍNAS E DERIVADOS",
	"4634602": "COMÉRCIO ATACADISTA DE AVES ABATIDAS E DERIVADOS",
	"4634603": "COMÉRCIO ATACADISTA DE PESCADOS E FRUTOS DO MAR",
	"4634699": "COMÉRCIO ATACADISTA DE CARNES E DERIVADOS DE OUTROS ANIMAIS",
	"4635401": "COMÉRCIO ATACADISTA DE ÁGUA MINERAL",
	"4635402": "COMÉRCIO ATACADISTA DE CERVEJA, CHOPE E REFRIGERANTE",
	"4635403":
		"COMÉRCIO ATACADISTA DE BEBIDAS COM ATIVIDADE DE FRACIONAMENTO E ACONDICIONAMENTO ASSOCIADA",
	"4635499": "COMÉRCIO ATACADISTA DE BEBIDAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"4636201": "COMÉRCIO ATACADISTA DE FUMO BENEFICIADO",
	"4636202": "COMÉRCIO ATACADISTA DE CIGARROS, CIGARRILHAS E CHARUTOS",
	"4637101": "COMÉRCIO ATACADISTA DE CAFÉ TORRADO, MOÍDO E SOLÚVEL",
	"4637102": "COMÉRCIO ATACADISTA DE AÇÚCAR",
	"4637103": "COMÉRCIO ATACADISTA DE ÓLEOS E GORDURAS",
	"4637104": "COMÉRCIO ATACADISTA DE PÃES, BOLOS, BISCOITOS E SIMILARES",
	"4637105": "COMÉRCIO ATACADISTA DE MASSAS ALIMENTÍCIAS",
	"4637106": "COMÉRCIO ATACADISTA DE SORVETES",
	"4637107": "COMÉRCIO ATACADISTA DE CHOCOLATES, CONFEITOS, BALAS, BOMBONS E SEMELHANTES",
	"4637199":
		"COMÉRCIO ATACADISTA ESPECIALIZADO EM OUTROS PRODUTOS ALIMENTÍCIOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4639701": "COMÉRCIO ATACADISTA DE PRODUTOS ALIMENTÍCIOS EM GERAL",
	"4639702":
		"COMÉRCIO ATACADISTA DE PRODUTOS ALIMENTÍCIOS EM GERAL, COM ATIVIDADE DE FRACIONAMENTO E ACONDICIONAMENTO ASSOCIADA",
	"4641901": "COMÉRCIO ATACADISTA DE TECIDOS",
	"4641902": "COMÉRCIO ATACADISTA DE ARTIGOS DE CAMA, MESA E BANHO",
	"4641903": "COMÉRCIO ATACADISTA DE ARTIGOS DE ARMARINHO",
	"4642701":
		"COMÉRCIO ATACADISTA DE ARTIGOS DO VESTUÁRIO E ACESSÓRIOS, EXCETO PROFISSIONAIS E DE SEGURANÇA",
	"4642702":
		"COMÉRCIO ATACADISTA DE ROUPAS E ACESSÓRIOS PARA USO PROFISSIONAL E DE SEGURANÇA DO TRABALHO",
	"4643501": "COMÉRCIO ATACADISTA DE CALÇADOS",
	"4643502": "COMÉRCIO ATACADISTA DE BOLSAS, MALAS E ARTIGOS DE VIAGEM",
	"4644301": "COMÉRCIO ATACADISTA DE MEDICAMENTOS E DROGAS DE USO HUMANO",
	"4644302": "COMÉRCIO ATACADISTA DE MEDICAMENTOS E DROGAS DE USO VETERINÁRIO",
	"4645101":
		"COMÉRCIO ATACADISTA DE INSTRUMENTOS E MATERIAIS PARA USO MÉDICO, CIRÚRGICO, HOSPITALAR E DE LABORATÓRIOS",
	"4645102": "COMÉRCIO ATACADISTA DE PRÓTESES E ARTIGOS DE ORTOPEDIA",
	"4645103": "COMÉRCIO ATACADISTA DE PRODUTOS ODONTOLÓGICOS",
	"4646001": "COMÉRCIO ATACADISTA DE COSMÉTICOS E PRODUTOS DE PERFUMARIA",
	"4646002": "COMÉRCIO ATACADISTA DE PRODUTOS DE HIGIENE PESSOAL",
	"4647801": "COMÉRCIO ATACADISTA DE ARTIGOS DE ESCRITÓRIO E DE PAPELARIA",
	"4647802": "COMÉRCIO ATACADISTA DE LIVROS, JORNAIS E OUTRAS PUBLICAÇÕES",
	"4649401": "COMÉRCIO ATACADISTA DE EQUIPAMENTOS ELÉTRICOS DE USO PESSOAL E DOMÉSTICO",
	"4649402": "COMÉRCIO ATACADISTA DE APARELHOS ELETRÔNICOS DE USO PESSOAL E DOMÉSTICO",
	"4649403": "COMÉRCIO ATACADISTA DE BICICLETAS, TRICICLOS E OUTROS VEÍCULOS RECREATIVOS",
	"4649404": "COMÉRCIO ATACADISTA DE MÓVEIS E ARTIGOS DE COLCHOARIA",
	"4649405": "COMÉRCIO ATACADISTA DE ARTIGOS DE TAPEÇARIA; PERSIANAS E CORTINAS",
	"4649406": "COMÉRCIO ATACADISTA DE LUSTRES, LUMINÁRIAS E ABAJURES",
	"4649407": "COMÉRCIO ATACADISTA DE FILMES, CDS, DVDS, FITAS E DISCOS",
	"4649408": "COMÉRCIO ATACADISTA DE PRODUTOS DE HIGIENE, LIMPEZA E CONSERVAÇÃO DOMICILIAR",
	"4649409":
		"COMÉRCIO ATACADISTA DE PRODUTOS DE HIGIENE, LIMPEZA E CONSERVAÇÃO DOMICILIAR, COM ATIVIDADE DE FRACIONAMENTO E ACONDICIONAMENTO ASSOCIADA",
	"4649410":
		"COMÉRCIO ATACADISTA DE JÓIAS, RELÓGIOS E BIJUTERIAS, INCLUSIVE PEDRAS PRECIOSAS E SEMIPRECIOSAS LAPIDADAS",
	"4649499":
		"COMÉRCIO ATACADISTA DE OUTROS EQUIPAMENTOS E ARTIGOS DE USO PESSOAL E DOMÉSTICO NÃO ESPECIFICADOS ANTERIORMENTE",
	"4651601": "COMÉRCIO ATACADISTA DE EQUIPAMENTOS DE INFORMÁTICA",
	"4651602": "COMÉRCIO ATACADISTA DE SUPRIMENTOS PARA INFORMÁTICA",
	"4652400":
		"COMÉRCIO ATACADISTA DE COMPONENTES ELETRÔNICOS E EQUIPAMENTOS DE TELEFONIA E COMUNICAÇÃO",
	"4661300":
		"COMÉRCIO ATACADISTA DE MÁQUINAS, APARELHOS E EQUIPAMENTOS PARA USO AGROPECUÁRIO; PARTES E PEÇAS",
	"4662100":
		"COMÉRCIO ATACADISTA DE MÁQUINAS, EQUIPAMENTOS PARA TERRAPLENAGEM, MINERAÇÃO E CONSTRUÇÃO; PARTES E PEÇAS",
	"4663000": "COMÉRCIO ATACADISTA DE MÁQUINAS E EQUIPAMENTOS PARA USO INDUSTRIAL; PARTES E PEÇAS",
	"4664800":
		"COMÉRCIO ATACADISTA DE MÁQUINAS, APARELHOS E EQUIPAMENTOS PARA USO ODONTO MÉDICO HOSPITALAR; PARTES E PEÇAS",
	"4665600": "COMÉRCIO ATACADISTA DE MÁQUINAS E EQUIPAMENTOS PARA USO COMERCIAL; PARTES E PEÇAS",
	"4669901": "COMÉRCIO ATACADISTA DE BOMBAS E COMPRESSORES; PARTES E PEÇAS",
	"4669999":
		"COMÉRCIO ATACADISTA DE OUTRAS MÁQUINAS E EQUIPAMENTOS NÃO ESPECIFICADOS ANTERIORMENTE; PARTES E PEÇAS",
	"4671100": "COMÉRCIO ATACADISTA DE MADEIRA E PRODUTOS DERIVADOS",
	"4672900": "COMÉRCIO ATACADISTA DE FERRAGENS E FERRAMENTAS",
	"4673700": "COMÉRCIO ATACADISTA DE MATERIAL ELÉTRICO",
	"4674500": "COMÉRCIO ATACADISTA DE CIMENTO",
	"4679601": "COMÉRCIO ATACADISTA DE TINTAS, VERNIZES E SIMILARES",
	"4679602": "COMÉRCIO ATACADISTA DE MÁRMORES E GRANITOS",
	"4679603": "COMÉRCIO ATACADISTA DE VIDROS, ESPELHOS E VITRAIS",
	"4679604":
		"COMÉRCIO ATACADISTA ESPECIALIZADO DE MATERIAIS DE CONSTRUÇÃO NÃO ESPECIFICADOS ANTERIORMENTE",
	"4679699": "COMÉRCIO ATACADISTA DE MATERIAIS DE CONSTRUÇÃO EM GERAL",
	"4681801":
		"COMÉRCIO ATACADISTA DE ÁLCOOL CARBURANTE, BIODIESEL, GASOLINA E DEMAIS DERIVADOS DE PETRÓLEO, EXCETO LUBRIFICANTES, NÃO REALIZADO POR TRANSPORTADOR RETALHISTA (T.R.R.)",
	"4681802": "COMÉRCIO ATACADISTA DE COMBUSTÍVEIS REALIZADO POR TRANSPORTADOR RETALHISTA (T.R.R.)",
	"4681803": "COMÉRCIO ATACADISTA DE COMBUSTÍVEIS DE ORIGEM VEGETAL, EXCETO ÁLCOOL CARBURANTE",
	"4681804": "COMÉRCIO ATACADISTA DE COMBUSTÍVEIS DE ORIGEM MINERAL EM BRUTO",
	"4681805": "COMÉRCIO ATACADISTA DE LUBRIFICANTES",
	"4682600": "COMÉRCIO ATACADISTA DE GÁS LIQÜEFEITO DE PETRÓLEO (GLP)",
	"4683400":
		"COMÉRCIO ATACADISTA DE DEFENSIVOS AGRÍCOLAS, ADUBOS, FERTILIZANTES E CORRETIVOS DO SOLO",
	"4684201": "COMÉRCIO ATACADISTA DE RESINAS E ELASTÔMEROS",
	"4684202": "COMÉRCIO ATACADISTA DE SOLVENTES",
	"4684299":
		"COMÉRCIO ATACADISTA DE OUTROS PRODUTOS QUÍMICOS E PETROQUÍMICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4685100": "COMÉRCIO ATACADISTA DE PRODUTOS SIDERÚRGICOS E METALÚRGICOS, EXCETO PARA CONSTRUÇÃO",
	"4686901": "COMÉRCIO ATACADISTA DE PAPEL E PAPELÃO EM BRUTO",
	"4686902": "COMÉRCIO ATACADISTA DE EMBALAGENS",
	"4687701": "COMÉRCIO ATACADISTA DE RESÍDUOS DE PAPEL E PAPELÃO",
	"4687702": "COMÉRCIO ATACADISTA DE RESÍDUOS E SUCATAS NÃO METÁLICOS, EXCETO DE PAPEL E PAPELÃO",
	"4687703": "COMÉRCIO ATACADISTA DE RESÍDUOS E SUCATAS METÁLICOS",
	"4689301": "COMÉRCIO ATACADISTA DE PRODUTOS DA EXTRAÇÃO MINERAL, EXCETO COMBUSTÍVEIS",
	"4689302": "COMÉRCIO ATACADISTA DE FIOS E FIBRAS BENEFICIADOS",
	"4689399":
		"COMÉRCIO ATACADISTA ESPECIALIZADO EM OUTROS PRODUTOS INTERMEDIÁRIOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4691500":
		"COMÉRCIO ATACADISTA DE MERCADORIAS EM GERAL, COM PREDOMINÂNCIA DE PRODUTOS ALIMENTÍCIOS",
	"4692300":
		"COMÉRCIO ATACADISTA DE MERCADORIAS EM GERAL, COM PREDOMINÂNCIA DE INSUMOS AGROPECUÁRIOS",
	"4693100":
		"COMÉRCIO ATACADISTA DE MERCADORIAS EM GERAL, SEM PREDOMINÂNCIA DE ALIMENTOS OU DE INSUMOS AGROPECUÁRIOS",
	"4711301":
		"COMÉRCIO VAREJISTA DE MERCADORIAS EM GERAL, COM PREDOMINÂNCIA DE PRODUTOS ALIMENTÍCIOS   HIPERMERCADOS",
	"4711302":
		"COMÉRCIO VAREJISTA DE MERCADORIAS EM GERAL, COM PREDOMINÂNCIA DE PRODUTOS ALIMENTÍCIOS - SUPERMERCADOS",
	"4712100":
		"COMÉRCIO VAREJISTA DE MERCADORIAS EM GERAL, COM PREDOMINÂNCIA DE PRODUTOS ALIMENTÍCIOS - MINIMERCADOS, MERCEARIAS E ARMAZÉNS",
	"4713002": "LOJAS DE VARIEDADES, EXCETO LOJAS DE DEPARTAMENTOS OU MAGAZINES",
	"4713004": "LOJAS DE DEPARTAMENTOS OU MAGAZINES, EXCETO LOJAS FRANCAS (DUTY FREE)",
	"4713005": "LOJAS FRANCAS (DUTY FREE) DE AEROPORTOS, PORTOS E EM FRONTEIRAS TERRESTRES",
	"4721102": "PADARIA E CONFEITARIA COM PREDOMINÂNCIA DE REVENDA",
	"4721103": "COMÉRCIO VAREJISTA DE LATICÍNIOS E FRIOS",
	"4721104": "COMÉRCIO VAREJISTA DE DOCES, BALAS, BOMBONS E SEMELHANTES",
	"4722901": "COMÉRCIO VAREJISTA DE CARNES - AÇOUGUES",
	"4722902": "PEIXARIA",
	"4723700": "COMÉRCIO VAREJISTA DE BEBIDAS",
	"4724500": "COMÉRCIO VAREJISTA DE HORTIFRUTIGRANJEIROS",
	"4729601": "TABACARIA",
	"4729602": "COMÉRCIO VAREJISTA DE MERCADORIAS EM LOJAS DE CONVENIÊNCIA",
	"4729699":
		"COMÉRCIO VAREJISTA DE PRODUTOS ALIMENTÍCIOS EM GERAL OU ESPECIALIZADO EM PRODUTOS ALIMENTÍCIOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4731800": "COMÉRCIO VAREJISTA DE COMBUSTÍVEIS PARA VEÍCULOS AUTOMOTORES",
	"4732600": "COMÉRCIO VAREJISTA DE LUBRIFICANTES",
	"4741500": "COMÉRCIO VAREJISTA DE TINTAS E MATERIAIS PARA PINTURA",
	"4742300": "COMÉRCIO VAREJISTA DE MATERIAL ELÉTRICO",
	"4743100": "COMÉRCIO VAREJISTA DE VIDROS",
	"4744001": "COMÉRCIO VAREJISTA DE FERRAGENS E FERRAMENTAS",
	"4744002": "COMÉRCIO VAREJISTA DE MADEIRA E ARTEFATOS",
	"4744003": "COMÉRCIO VAREJISTA DE MATERIAIS HIDRÁULICOS",
	"4744004": "COMÉRCIO VAREJISTA DE CAL, AREIA, PEDRA BRITADA, TIJOLOS E TELHAS",
	"4744005": "COMÉRCIO VAREJISTA DE MATERIAIS DE CONSTRUÇÃO NÃO ESPECIFICADOS ANTERIORMENTE",
	"4744006": "COMÉRCIO VAREJISTA DE PEDRAS PARA REVESTIMENTO",
	"4744099": "COMÉRCIO VAREJISTA DE MATERIAIS DE CONSTRUÇÃO EM GERAL",
	"4751201": "COMÉRCIO VAREJISTA ESPECIALIZADO DE EQUIPAMENTOS E SUPRIMENTOS DE INFORMÁTICA",
	"4751202": "RECARGA DE CARTUCHOS PARA EQUIPAMENTOS DE INFORMÁTICA",
	"4752100": "COMÉRCIO VAREJISTA ESPECIALIZADO DE EQUIPAMENTOS DE TELEFONIA E COMUNICAÇÃO",
	"4753900": "COMÉRCIO VAREJISTA ESPECIALIZADO DE ELETRODOMÉSTICOS E EQUIPAMENTOS DE ÁUDIO E VÍDEO",
	"4754701": "COMÉRCIO VAREJISTA DE MÓVEIS",
	"4754702": "COMÉRCIO VAREJISTA DE ARTIGOS DE COLCHOARIA",
	"4754703": "COMÉRCIO VAREJISTA DE ARTIGOS DE ILUMINAÇÃO",
	"4755501": "COMÉRCIO VAREJISTA DE TECIDOS",
	"4755502": "COMERCIO VAREJISTA DE ARTIGOS DE ARMARINHO",
	"4755503": "COMERCIO VAREJISTA DE ARTIGOS DE CAMA, MESA E BANHO",
	"4756300": "COMÉRCIO VAREJISTA ESPECIALIZADO DE INSTRUMENTOS MUSICAIS E ACESSÓRIOS",
	"4757100":
		"COMÉRCIO VAREJISTA ESPECIALIZADO DE PEÇAS E ACESSÓRIOS PARA APARELHOS ELETROELETRÔNICOS PARA USO DOMÉSTICO, EXCETO INFORMÁTICA E COMUNICAÇÃO",
	"4759801": "COMÉRCIO VAREJISTA DE ARTIGOS DE TAPEÇARIA, CORTINAS E PERSIANAS",
	"4759899":
		"COMÉRCIO VAREJISTA DE OUTROS ARTIGOS DE USO PESSOAL E DOMÉSTICO NÃO ESPECIFICADOS ANTERIORMENTE",
	"4761001": "COMÉRCIO VAREJISTA DE LIVROS",
	"4761002": "COMÉRCIO VAREJISTA DE JORNAIS E REVISTAS",
	"4761003": "COMÉRCIO VAREJISTA DE ARTIGOS DE PAPELARIA",
	"4762800": "COMÉRCIO VAREJISTA DE DISCOS, CDS, DVDS E FITAS",
	"4763601": "COMÉRCIO VAREJISTA DE BRINQUEDOS E ARTIGOS RECREATIVOS",
	"4763602": "COMÉRCIO VAREJISTA DE ARTIGOS ESPORTIVOS",
	"4763603": "COMÉRCIO VAREJISTA DE BICICLETAS E TRICICLOS; PEÇAS E ACESSÓRIOS",
	"4763604": "COMÉRCIO VAREJISTA DE ARTIGOS DE CAÇA, PESCA E CAMPING",
	"4763605": "COMÉRCIO VAREJISTA DE EMBARCAÇÕES E OUTROS VEÍCULOS RECREATIVOS; PEÇAS E ACESSÓRIOS",
	"4771701": "COMÉRCIO VAREJISTA DE PRODUTOS FARMACÊUTICOS, SEM MANIPULAÇÃO DE FÓRMULAS",
	"4771702": "COMÉRCIO VAREJISTA DE PRODUTOS FARMACÊUTICOS, COM MANIPULAÇÃO DE FÓRMULAS",
	"4771703": "COMÉRCIO VAREJISTA DE PRODUTOS FARMACÊUTICOS HOMEOPÁTICOS",
	"4771704": "COMÉRCIO VAREJISTA DE MEDICAMENTOS VETERINÁRIOS",
	"4772500": "COMÉRCIO VAREJISTA DE COSMÉTICOS, PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL",
	"4773300": "COMÉRCIO VAREJISTA DE ARTIGOS MÉDICOS E ORTOPÉDICOS",
	"4774100": "COMÉRCIO VAREJISTA DE ARTIGOS DE ÓPTICA",
	"4781400": "COMÉRCIO VAREJISTA DE ARTIGOS DO VESTUÁRIO E ACESSÓRIOS",
	"4782201": "COMÉRCIO VAREJISTA DE CALÇADOS",
	"4782202": "COMÉRCIO VAREJISTA DE ARTIGOS DE VIAGEM",
	"4783101": "COMÉRCIO VAREJISTA DE ARTIGOS DE JOALHERIA",
	"4783102": "COMÉRCIO VAREJISTA DE ARTIGOS DE RELOJOARIA",
	"4784900": "COMÉRCIO VAREJISTA DE GÁS LIQÜEFEITO DE PETRÓLEO (GLP)",
	"4785701": "COMÉRCIO VAREJISTA DE ANTIGÜIDADES",
	"4785799": "COMÉRCIO VAREJISTA DE OUTROS ARTIGOS USADOS",
	"4789001": "COMÉRCIO VAREJISTA DE SUVENIRES, BIJUTERIAS E ARTESANATOS",
	"4789002": "COMÉRCIO VAREJISTA DE PLANTAS E FLORES NATURAIS",
	"4789003": "COMÉRCIO VAREJISTA DE OBJETOS DE ARTE",
	"4789004":
		"COMÉRCIO VAREJISTA DE ANIMAIS VIVOS E DE ARTIGOS E ALIMENTOS PARA ANIMAIS DE ESTIMAÇÃO",
	"4789005": "COMÉRCIO VAREJISTA DE PRODUTOS SANEANTES DOMISSANITÁRIOS",
	"4789006": "COMÉRCIO VAREJISTA DE FOGOS DE ARTIFÍCIO E ARTIGOS PIROTÉCNICOS",
	"4789007": "COMÉRCIO VAREJISTA DE EQUIPAMENTOS PARA ESCRITÓRIO",
	"4789008": "COMÉRCIO VAREJISTA DE ARTIGOS FOTOGRÁFICOS E PARA FILMAGEM",
	"4789009": "COMÉRCIO VAREJISTA DE ARMAS E MUNIÇÕES",
	"4789099": "COMÉRCIO VAREJISTA DE OUTROS PRODUTOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4911600": "TRANSPORTE FERROVIÁRIO DE CARGA",
	"4912401": "TRANSPORTE FERROVIÁRIO DE PASSAGEIROS INTERMUNICIPAL E INTERESTADUAL",
	"4912402": "TRANSPORTE FERROVIÁRIO DE PASSAGEIROS MUNICIPAL E EM REGIÃO METROPOLITANA",
	"4912403": "TRANSPORTE METROVIÁRIO",
	"4921301": "TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, COM ITINERÁRIO FIXO, MUNICIPAL",
	"4921302":
		"TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, COM ITINERÁRIO FIXO, INTERMUNICIPAL EM REGIÃO METROPOLITANA",
	"4922101":
		"TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, COM ITINERÁRIO FIXO, INTERMUNICIPAL, EXCETO EM REGIÃO METROPOLITANA",
	"4922102": "TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, COM ITINERÁRIO FIXO, INTERESTADUAL",
	"4922103": "TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, COM ITINERÁRIO FIXO, INTERNACIONAL",
	"4923001": "SERVIÇO DE TÁXI",
	"4923002": "SERVIÇO DE TRANSPORTE DE PASSAGEIROS - LOCAÇÃO DE AUTOMÓVEIS COM MOTORISTA",
	"4924800": "TRANSPORTE ESCOLAR",
	"4929901": "TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, SOB REGIME DE FRETAMENTO, MUNICIPAL",
	"4929902":
		"TRANSPORTE RODOVIÁRIO COLETIVO DE PASSAGEIROS, SOB REGIME DE FRETAMENTO, INTERMUNICIPAL, INTERESTADUAL E INTERNACIONAL",
	"4929903": "ORGANIZAÇÃO DE EXCURSÕES EM VEÍCULOS RODOVIÁRIOS PRÓPRIOS, MUNICIPAL",
	"4929904":
		"ORGANIZAÇÃO DE EXCURSÕES EM VEÍCULOS RODOVIÁRIOS PRÓPRIOS, INTERMUNICIPAL, INTERESTADUAL E INTERNACIONAL",
	"4929999": "OUTROS TRANSPORTES RODOVIÁRIOS DE PASSAGEIROS NÃO ESPECIFICADOS ANTERIORMENTE",
	"4930201": "TRANSPORTE RODOVIÁRIO DE CARGA, EXCETO PRODUTOS PERIGOSOS E MUDANÇAS, MUNICIPAL",
	"4930202":
		"TRANSPORTE RODOVIÁRIO DE CARGA, EXCETO PRODUTOS PERIGOSOS E MUDANÇAS, INTERMUNICIPAL, INTERESTADUAL E INTERNACIONAL",
	"4930203": "TRANSPORTE RODOVIÁRIO DE PRODUTOS PERIGOSOS",
	"4930204": "TRANSPORTE RODOVIÁRIO DE MUDANÇAS",
	"4940000": "TRANSPORTE DUTOVIÁRIO",
	"4950700": "TRENS TURÍSTICOS, TELEFÉRICOS E SIMILARES",
	"5011401": "TRANSPORTE MARÍTIMO DE CABOTAGEM - CARGA",
	"5011402": "TRANSPORTE MARÍTIMO DE CABOTAGEM - PASSAGEIROS",
	"5012201": "TRANSPORTE MARÍTIMO DE LONGO CURSO - CARGA",
	"5012202": "TRANSPORTE MARÍTIMO DE LONGO CURSO - PASSAGEIROS",
	"5021101": "TRANSPORTE POR NAVEGAÇÃO INTERIOR DE CARGA, MUNICIPAL, EXCETO TRAVESSIA",
	"5021102":
		"TRANSPORTE POR NAVEGAÇÃO INTERIOR DE CARGA, INTERMUNICIPAL, INTERESTADUAL E INTERNACIONAL, EXCETO TRAVESSIA",
	"5022001":
		"TRANSPORTE POR NAVEGAÇÃO INTERIOR DE PASSAGEIROS EM LINHAS REGULARES, MUNICIPAL, EXCETO TRAVESSIA",
	"5022002":
		"TRANSPORTE POR NAVEGAÇÃO INTERIOR DE PASSAGEIROS EM LINHAS REGULARES, INTERMUNICIPAL, INTERESTADUAL E INTERNACIONAL, EXCETO TRAVESSIA",
	"5030101": "NAVEGAÇÃO DE APOIO MARÍTIMO",
	"5030102": "NAVEGAÇÃO DE APOIO PORTUÁRIO",
	"5030103": "SERVIÇO DE REBOCADORES E EMPURRADORES",
	"5091201": "TRANSPORTE POR NAVEGAÇÃO DE TRAVESSIA, MUNICIPAL",
	"5091202": "TRANSPORTE POR NAVEGAÇÃO DE TRAVESSIA INTERMUNICIPAL, INTERESTADUAL E INTERNACIONAL",
	"5099801": "TRANSPORTE AQUAVIÁRIO PARA PASSEIOS TURÍSTICOS",
	"5099899": "OUTROS TRANSPORTES AQUAVIÁRIOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"5111100": "TRANSPORTE AÉREO DE PASSAGEIROS REGULAR",
	"5112901": "SERVIÇO DE TÁXI AÉREO E LOCAÇÃO DE AERONAVES COM TRIPULAÇÃO",
	"5112999": "OUTROS SERVIÇOS DE TRANSPORTE AÉREO DE PASSAGEIROS NÃO REGULAR",
	"5120000": "TRANSPORTE AÉREO DE CARGA",
	"5130700": "TRANSPORTE ESPACIAL",
	"5211701": "ARMAZÉNS GERAIS - EMISSÃO DE WARRANT",
	"5211702": "GUARDA MÓVEIS",
	"5211799": "DEPÓSITOS DE MERCADORIAS PARA TERCEIROS, EXCETO ARMAZÉNS GERAIS E GUARDA MÓVEIS",
	"5212500": "CARGA E DESCARGA",
	"5221400": "CONCESSIONÁRIAS DE RODOVIAS, PONTES, TÚNEIS E SERVIÇOS RELACIONADOS",
	"5222200": "TERMINAIS RODOVIÁRIOS E FERROVIÁRIOS",
	"5223100": "ESTACIONAMENTO DE VEÍCULOS",
	"5229001": "SERVIÇOS DE APOIO AO TRANSPORTE POR TÁXI, INCLUSIVE CENTRAIS DE CHAMADA",
	"5229002": "SERVIÇOS DE REBOQUE DE VEÍCULOS",
	"5229099":
		"OUTRAS ATIVIDADES AUXILIARES DOS TRANSPORTES TERRESTRES NÃO ESPECIFICADAS ANTERIORMENTE",
	"5231101": "ADMINISTRAÇÃO DA INFRAESTRUTURA PORTUÁRIA",
	"5231102": "ATIVIDADES DO OPERADOR PORTUÁRIO",
	"5231103": "GESTÃO DE TERMINAIS AQUAVIÁRIOS",
	"5232000": "ATIVIDADES DE AGENCIAMENTO MARÍTIMO",
	"5239701": "SERVIÇOS DE PRATICAGEM",
	"5239799": "ATIVIDADES AUXILIARES DOS TRANSPORTES AQUAVIÁRIOS NÃO ESPECIFICADAS ANTERIORMENTE",
	"5240101": "OPERAÇÃO DOS AEROPORTOS E CAMPOS DE ATERRISSAGEM",
	"5240199":
		"ATIVIDADES AUXILIARES DOS TRANSPORTES AÉREOS, EXCETO OPERAÇÃO DOS AEROPORTOS E CAMPOS DE ATERRISSAGEM",
	"5250801": "COMISSARIA DE DESPACHOS",
	"5250802": "ATIVIDADES DE DESPACHANTES ADUANEIROS",
	"5250803": "AGENCIAMENTO DE CARGAS, EXCETO PARA O TRANSPORTE MARÍTIMO",
	"5250804": "ORGANIZAÇÃO LOGÍSTICA DO TRANSPORTE DE CARGA",
	"5250805": "OPERADOR DE TRANSPORTE MULTIMODAL - OTM",
	"5310501": "ATIVIDADES DO CORREIO NACIONAL",
	"5310502": "ATIVIDADES DE FRANQUEADAS DO CORREIO NACIONAL",
	"5320201": "SERVIÇOS DE MALOTE NÃO REALIZADOS PELO CORREIO NACIONAL",
	"5320202": "SERVIÇOS DE ENTREGA RÁPIDA",
	"5510801": "HOTÉIS",
	"5510802": "APART HOTÉIS",
	"5510803": "MOTÉIS",
	"5590601": "ALBERGUES, EXCETO ASSISTENCIAIS",
	"5590602": "CAMPINGS",
	"5590603": "PENSÕES(ALOJAMENTO)",
	"5590699": "OUTROS ALOJAMENTOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"5611201": "RESTAURANTES E SIMILARES",
	"5611203": "LANCHONETES, CASAS DE CHÁ, DE SUCOS E SIMILARES",
	"5611204": "BARES E OUTROS ESTABELECIMENTOS ESPECIALIZADOS EM SERVIR BEBIDAS, SEM ENTRETENIMENTO",
	"5611205":
		"BARES E OUTROS ESTABELECIMENTOS ESPECIALIZADOS EM SERVIR BEBIDAS, COM ENTRETENIMENTO ",
	"5612100": "SERVIÇOS AMBULANTES DE ALIMENTAÇÃO",
	"5620101": "FORNECIMENTO DE ALIMENTOS PREPARADOS PREPONDERANTEMENTE PARA EMPRESAS",
	"5620102": "SERVIÇOS DE ALIMENTAÇÃO PARA EVENTOS E RECEPÇÕES - BUFÊ",
	"5620103": "CANTINAS - SERVIÇOS DE ALIMENTAÇÃO PRIVATIVOS",
	"5620104": "FORNECIMENTO DE ALIMENTOS PREPARADOS PREPONDERANTEMENTE PARA CONSUMO DOMICILIAR",
	"5811500": "EDIÇÃO DE LIVROS",
	"5812301": "EDIÇÃO DE JORNAIS DIÁRIOS",
	"5812302": "EDIÇÃO DE JORNAIS NÃO DIÁRIOS",
	"5813100": "EDIÇÃO DE REVISTAS",
	"5819100": "EDIÇÃO DE CADASTROS, LISTAS E DE OUTROS PRODUTOS GRÁFICOS",
	"5821200": "EDIÇÃO INTEGRADA À IMPRESSÃO DE LIVROS",
	"5822101": "EDIÇÃO INTEGRADA À IMPRESSÃO DE JORNAIS DIÁRIOS",
	"5822102": "EDIÇÃO INTEGRADA À IMPRESSÃO DE JORNAIS NÃO DIÁRIOS",
	"5823900": "EDIÇÃO INTEGRADA À IMPRESSÃO DE REVISTAS",
	"5829800": "EDIÇÃO INTEGRADA À IMPRESSÃO DE CADASTROS, LISTAS E DE OUTROS PRODUTOS GRÁFICOS",
	"5911101": "ESTÚDIOS CINEMATOGRÁFICOS",
	"5911102": "PRODUÇÃO DE FILMES PARA PUBLICIDADE",
	"5911199":
		"ATIVIDADES DE PRODUÇÃO CINEMATOGRÁFICA, DE VÍDEOS E DE PROGRAMAS DE TELEVISÃO NÃO ESPECIFICADAS ANTERIORMENTE",
	"5912001": "SERVIÇOS DE DUBLAGEM",
	"5912002": "SERVIÇOS DE MIXAGEM SONORA EM PRODUÇÃO AUDIOVISUAL",
	"5912099":
		"ATIVIDADES DE PÓS PRODUÇÃO CINEMATOGRÁFICA, DE VÍDEOS E DE PROGRAMAS DE TELEVISÃO NÃO ESPECIFICADAS ANTERIORMENTE",
	"5913800": "DISTRIBUIÇÃO CINEMATOGRÁFICA, DE VÍDEO E DE PROGRAMAS DE TELEVISÃO",
	"5914600": "ATIVIDADES DE EXIBIÇÃO CINEMATOGRÁFICA",
	"5920100": "ATIVIDADES DE GRAVAÇÃO DE SOM E DE EDIÇÃO DE MÚSICA",
	"6010100": "ATIVIDADES DE RÁDIO",
	"6021700": "ATIVIDADES DE TELEVISÃO ABERTA",
	"6022501": "PROGRAMADORAS",
	"6022502": "ATIVIDADES RELACIONADAS À TELEVISÃO POR ASSINATURA, EXCETO PROGRAMADORAS",
	"6110801": "SERVIÇOS DE TELEFONIA FIXA COMUTADA - STFC",
	"6110802": "SERVIÇOS DE REDES DE TRANSPORTES DE TELECOMUNICAÇÕES - SRTT",
	"6110803": "SERVIÇOS DE COMUNICAÇÃO MULTIMÍDIA - SCM",
	"6110899": "SERVIÇOS DE TELECOMUNICAÇÕES POR FIO NÃO ESPECIFICADOS ANTERIORMENTE",
	"6120501": "TELEFONIA MÓVEL CELULAR",
	"6120502": "SERVIÇO MÓVEL ESPECIALIZADO - SME",
	"6120599": "SERVIÇOS DE TELECOMUNICAÇÕES SEM FIO NÃO ESPECIFICADOS ANTERIORMENTE",
	"6130200": "TELECOMUNICAÇÕES POR SATÉLITE",
	"6141800": "OPERADORAS DE TELEVISÃO POR ASSINATURA POR CABO",
	"6142600": "OPERADORAS DE TELEVISÃO POR ASSINATURA POR MICROONDAS",
	"6143400": "OPERADORAS DE TELEVISÃO POR ASSINATURA POR SATÉLITE",
	"6190601": "PROVEDORES DE ACESSO ÀS REDES DE COMUNICAÇÕES",
	"6190602": "PROVEDORES DE VOZ SOBRE PROTOCOLO INTERNET - VOIP",
	"6190699": "OUTRAS ATIVIDADES DE TELECOMUNICAÇÕES NÃO ESPECIFICADAS ANTERIORMENTE",
	"6201501": "DESENVOLVIMENTO DE PROGRAMAS DE COMPUTADOR SOB ENCOMENDA",
	"6201502": "WEB DESIGN",
	"6202300": "DESENVOLVIMENTO E LICENCIAMENTO DE PROGRAMAS DE COMPUTADOR CUSTOMIZÁVEIS",
	"6203100": "DESENVOLVIMENTO E LICENCIAMENTO DE PROGRAMAS DE COMPUTADOR NÃO CUSTOMIZÁVEIS",
	"6204000": "CONSULTORIA EM TECNOLOGIA DA INFORMAÇÃO",
	"6209100": "SUPORTE TÉCNICO, MANUTENÇÃO E OUTROS SERVIÇOS EM TECNOLOGIA DA INFORMAÇÃO",
	"6311900":
		"TRATAMENTO DE DADOS, PROVEDORES DE SERVIÇOS DE APLICAÇÃO E SERVIÇOS DE HOSPEDAGEM NA INTERNET",
	"6319400": "PORTAIS, PROVEDORES DE CONTEÚDO E OUTROS SERVIÇOS DE INFORMAÇÃO NA INTERNET",
	"6391700": "AGÊNCIAS DE NOTÍCIAS",
	"6399200":
		"OUTRAS ATIVIDADES DE PRESTAÇÃO DE SERVIÇOS DE INFORMAÇÃO NÃO ESPECIFICADAS ANTERIORMENTE",
	"6410700": "BANCO CENTRAL",
	"6421200": "BANCOS COMERCIAIS",
	"6422100": "BANCOS MÚLTIPLOS, COM CARTEIRA COMERCIAL",
	"6423900": "CAIXAS ECONÔMICAS",
	"6424701": "BANCOS COOPERATIVOS",
	"6424702": "COOPERATIVAS CENTRAIS DE CRÉDITO",
	"6424703": "COOPERATIVAS DE CRÉDITO MÚTUO",
	"6424704": "COOPERATIVAS DE CRÉDITO RURAL",
	"6431000": "BANCOS MÚLTIPLOS, SEM CARTEIRA COMERCIAL",
	"6432800": "BANCOS DE INVESTIMENTO",
	"6433600": "BANCOS DE DESENVOLVIMENTO",
	"6434400": "AGÊNCIAS DE FOMENTO",
	"6435201": "SOCIEDADES DE CRÉDITO IMOBILIÁRIO",
	"6435202": "ASSOCIAÇÕES DE POUPANÇA E EMPRÉSTIMO",
	"6435203": "COMPANHIAS HIPOTECÁRIAS",
	"6436100": "SOCIEDADES DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO - FINANCEIRAS",
	"6437900": "SOCIEDADES DE CRÉDITO AO MICROEMPREENDEDOR",
	"6438701": "BANCOS DE CÂMBIO",
	"6438799": "OUTRAS INSTITUIÇÕES DE INTERMEDIAÇÃO NÃO MONETÁRIA",
	"6440900": "ARRENDAMENTO MERCANTIL",
	"6450600": "SOCIEDADES DE CAPITALIZAÇÃO",
	"6461100": "HOLDINGS DE INSTITUIÇÕES FINANCEIRAS",
	"6462000": "HOLDINGS DE INSTITUIÇÕES NÃO FINANCEIRAS",
	"6463800": "OUTRAS SOCIEDADES DE PARTICIPAÇÃO, EXCETO HOLDINGS",
	"6470101": "FUNDOS DE INVESTIMENTO, EXCETO PREVIDENCIÁRIOS E IMOBILIÁRIOS",
	"6470102": "FUNDOS DE INVESTIMENTO PREVIDENCIÁRIOS",
	"6470103": "FUNDOS DE INVESTIMENTO IMOBILIÁRIOS",
	"6491300": "SOCIEDADES DE FOMENTO MERCANTIL - FACTORING",
	"6492100": "SECURITIZAÇÃO DE CRÉDITOS",
	"6493000": "ADMINISTRAÇÃO DE CONSÓRCIOS PARA AQUISIÇÃO DE BENS E DIREITOS",
	"6499901": "CLUBES DE INVESTIMENTO",
	"6499902": "SOCIEDADES DE INVESTIMENTO",
	"6499903": "FUNDO GARANTIDOR DE CRÉDITO",
	"6499904": "CAIXAS DE FINANCIAMENTO DE CORPORAÇÕES",
	"6499905": "CONCESSÃO DE CRÉDITO PELAS OSCIP",
	"6499999": "OUTRAS ATIVIDADES DE SERVIÇOS FINANCEIROS NÃO ESPECIFICADAS ANTERIORMENTE",
	"6511101": "SOCIEDADE SEGURADORA DE SEGUROS VIDA",
	"6511102": "PLANOS DE AUXÍLIO FUNERAL",
	"6512000": "SOCIEDADE SEGURADORA DE SEGUROS NÃO VIDA",
	"6520100": "SOCIEDADE SEGURADORA DE SEGUROS SAÚDE",
	"6530800": "RESSEGUROS",
	"6541300": "PREVIDÊNCIA COMPLEMENTAR FECHADA",
	"6542100": "PREVIDÊNCIA COMPLEMENTAR ABERTA",
	"6550200": "PLANOS DE SAÚDE",
	"6611801": "BOLSA DE VALORES",
	"6611802": "BOLSA DE MERCADORIAS",
	"6611803": "BOLSA DE MERCADORIAS E FUTUROS",
	"6611804": "ADMINISTRAÇÃO DE MERCADOS DE BALCÃO ORGANIZADOS",
	"6612601": "CORRETORAS DE TÍTULOS E VALORES MOBILIÁRIOS",
	"6612602": "DISTRIBUIDORAS DE TÍTULOS E VALORES MOBILIÁRIOS",
	"6612603": "CORRETORAS DE CÂMBIO",
	"6612604": "CORRETORAS DE CONTRATOS DE MERCADORIAS",
	"6612605": "AGENTES DE INVESTIMENTOS EM APLICAÇÕES FINANCEIRAS",
	"6613400": "ADMINISTRAÇÃO DE CARTÕES DE CRÉDITO",
	"6619301": "SERVIÇOS DE LIQUIDAÇÃO E CUSTÓDIA",
	"6619302": "CORRESPONDENTES DE INSTITUIÇÕES FINANCEIRAS",
	"6619303": "REPRESENTAÇÕES DE BANCOS ESTRANGEIROS",
	"6619304": "CAIXAS ELETRÔNICOS",
	"6619305": "OPERADORAS DE CARTÕES DE DÉBITO",
	"6619399":
		"OUTRAS ATIVIDADES AUXILIARES DOS SERVIÇOS FINANCEIROS NÃO ESPECIFICADAS ANTERIORMENTE",
	"6621501": "PERITOS E AVALIADORES DE SEGUROS",
	"6621502": "AUDITORIA E CONSULTORIA ATUARIAL",
	"6622300": "CORRETORES E AGENTES DE SEGUROS, DE PLANOS DE PREVIDÊNCIA COMPLEMENTAR E DE SAÚDE",
	"6629100":
		"ATIVIDADES AUXILIARES DOS SEGUROS, DA PREVIDÊNCIA COMPLEMENTAR E DOS PLANOS DE SAÚDE NÃO ESPECIFICADAS ANTERIORMENTE",
	"6630400": "ATIVIDADES DE ADMINISTRAÇÃO DE FUNDOS POR CONTRATO OU COMISSÃO",
	"6810201": "COMPRA E VENDA DE IMÓVEIS PRÓPRIOS",
	"6810202": "ALUGUEL DE IMÓVEIS PRÓPRIOS",
	"6810203": "LOTEAMENTO DE IMÓVEIS PRÓPRIOS",
	"6821801": "CORRETAGEM NA COMPRA E VENDA E AVALIAÇÃO DE IMÓVEIS",
	"6821802": "CORRETAGEM NO ALUGUEL DE IMÓVEIS",
	"6822600": "GESTÃO E ADMINISTRAÇÃO DA PROPRIEDADE IMOBILIARIA",
	"6911701": "SERVIÇOS ADVOCATÍCIOS",
	"6911702": "ATIVIDADES AUXILIARES DA JUSTIÇA",
	"6911703": "AGENTE DE PROPRIEDADE INDUSTRIAL",
	"6912500": "CARTÓRIOS",
	"6920601": "ATIVIDADES DE CONTABILIDADE",
	"6920602": "ATIVIDADES DE CONSULTORIA E AUDITORIA CONTÁBIL E TRIBUTÁRIA",
	"7020400":
		"ATIVIDADES DE CONSULTORIA EM GESTÃO EMPRESARIAL, EXCETO CONSULTORIA TÉCNICA ESPECÍFICA",
	"7111100": "SERVIÇOS DE ARQUITETURA",
	"7112000": "SERVIÇOS DE ENGENHARIA",
	"7119701": "SERVIÇOS DE CARTOGRAFIA, TOPOGRAFIA E GEODÉSIA",
	"7119702": "ATIVIDADES DE ESTUDOS GEOLÓGICOS",
	"7119703": "SERVIÇOS DE DESENHO TÉCNICO RELACIONADOS À ARQUITETURA E ENGENHARIA",
	"7119704": "SERVIÇOS DE PERÍCIA TÉCNICA RELACIONADOS À SEGURANÇA DO TRABALHO",
	"7119799":
		"ATIVIDADES TÉCNICAS RELACIONADAS À ENGENHARIA E ARQUITETURA NÃO ESPECIFICADAS ANTERIORMENTE",
	"7120100": "TESTES E ANÁLISES TÉCNICAS",
	"7210000": "PESQUISA E DESENVOLVIMENTO EXPERIMENTAL EM CIÊNCIAS FÍSICAS E NATURAIS",
	"7220700": "PESQUISA E DESENVOLVIMENTO EXPERIMENTAL EM CIÊNCIAS SOCIAIS E HUMANAS",
	"7311400": "AGÊNCIAS DE PUBLICIDADE",
	"7312200": "AGENCIAMENTO DE ESPAÇOS PARA PUBLICIDADE, EXCETO EM VEÍCULOS DE COMUNICAÇÃO",
	"7319001": "CRIAÇÃO ESTANDES PARA FEIRAS E EXPOSIÇÕES",
	"7319002": "PROMOÇÃO DE VENDAS",
	"7319003": "MARKETING DIRETO",
	"7319004": "CONSULTORIA EM PUBLICIDADE",
	"7319099": "OUTRAS ATIVIDADES DE PUBLICIDADE NÃO ESPECIFICADAS ANTERIORMENTE",
	"7320300": "PESQUISAS DE MERCADO E DE OPINIÃO PÚBLICA",
	"7410202": "DESIGN DE INTERIORES",
	"7410203": "DESIGN DE PRODUTO",
	"7410299": "ATIVIDADES DE DESIGN NÃO ESPECIFICADAS ANTERIORMENTE",
	"7420001": "ATIVIDADES DE PRODUÇÃO DE FOTOGRAFIAS, EXCETO AÉREA E SUBMARINA",
	"7420002": "ATIVIDADES DE PRODUÇÃO DE FOTOGRAFIAS AÉREAS E SUBMARINAS",
	"7420003": "LABORATÓRIOS FOTOGRÁFICOS",
	"7420004": "FILMAGEM DE FESTAS E EVENTOS",
	"7420005": "SERVIÇOS DE MICROFILMAGEM",
	"7490101": "SERVIÇOS DE TRADUÇÃO, INTERPRETAÇÃO E SIMILARES",
	"7490102": "ESCAFANDRIA E MERGULHO",
	"7490103": "SERVIÇOS DE AGRONOMIA E DE CONSULTORIA ÀS ATIVIDADES AGRÍCOLAS E PECUÁRIAS",
	"7490104":
		"ATIVIDADES DE INTERMEDIAÇÃO E AGENCIAMENTO DE SERVIÇOS E NEGÓCIOS EM GERAL, EXCETO IMOBILIÁRIOS",
	"7490105": "AGENCIAMENTO DE PROFISSIONAIS PARA ATIVIDADES ESPORTIVAS, CULTURAIS E ARTÍSTICAS",
	"7490199":
		"OUTRAS ATIVIDADES PROFISSIONAIS, CIENTÍFICAS E TÉCNICAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"7500100": "ATIVIDADES VETERINÁRIAS",
	"7711000": "LOCAÇÃO DE AUTOMÓVEIS SEM CONDUTOR",
	"7719501": "LOCAÇÃO DE EMBARCAÇÕES SEM TRIPULAÇÃO, EXCETO PARA FINS RECREATIVOS",
	"7719502": "LOCAÇÃO DE AERONAVES SEM TRIPULAÇÃO",
	"7719599": "LOCAÇÃO DE OUTROS MEIOS DE TRANSPORTE NÃO ESPECIFICADOS ANTERIORMENTE, SEM CONDUTOR",
	"7721700": "ALUGUEL DE EQUIPAMENTOS RECREATIVOS E ESPORTIVOS",
	"7722500": "ALUGUEL DE FITAS DE VÍDEO, DVDS E SIMILARES",
	"7723300": "ALUGUEL DE OBJETOS DO VESTUÁRIO, JÓIAS E ACESSÓRIOS",
	"7729201": "ALUGUEL DE APARELHOS DE JOGOS ELETRÔNICOS",
	"7729202":
		"ALUGUEL DE MÓVEIS, UTENSÍLIOS E APARELHOS DE USO DOMÉSTICO E PESSOAL; INSTRUMENTOS MUSICAIS",
	"7729203": "ALUGUEL DE MATERIAL MÉDICO",
	"7729299": "ALUGUEL DE OUTROS OBJETOS PESSOAIS E DOMÉSTICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"7731400": "ALUGUEL DE MÁQUINAS E EQUIPAMENTOS AGRÍCOLAS SEM OPERADOR",
	"7732201": "ALUGUEL DE MÁQUINAS E EQUIPAMENTOS PARA CONSTRUÇÃO SEM OPERADOR, EXCETO ANDAIMES",
	"7732202": "ALUGUEL DE ANDAIMES",
	"7733100": "ALUGUEL DE MÁQUINAS E EQUIPAMENTOS PARA ESCRITÓRIOS",
	"7739001":
		"ALUGUEL DE MÁQUINAS E EQUIPAMENTOS PARA EXTRAÇÃO DE MINÉRIOS E PETRÓLEO, SEM OPERADOR",
	"7739002": "ALUGUEL DE EQUIPAMENTOS CIENTÍFICOS, MÉDICOS E HOSPITALARES, SEM OPERADOR",
	"7739003": "ALUGUEL DE PALCOS, COBERTURAS E OUTRAS ESTRUTURAS DE USO TEMPORÁRIO, EXCETO ANDAIMES",
	"7739099":
		"ALUGUEL DE OUTRAS MÁQUINAS E EQUIPAMENTOS COMERCIAIS E INDUSTRIAIS NÃO ESPECIFICADOS ANTERIORMENTE, SEM OPERADOR",
	"7740300": "GESTÃO DE ATIVOS INTANGÍVEIS NÃO FINANCEIROS",
	"7810800": "SELEÇÃO E AGENCIAMENTO DE MÃO DE OBRA",
	"7820500": "LOCAÇÃO DE MÃO DE OBRA TEMPORÁRIA",
	"7830200": "FORNECIMENTO E GESTÃO DE RECURSOS HUMANOS PARA TERCEIROS",
	"7911200": "AGÊNCIAS DE VIAGENS",
	"7912100": "OPERADORES TURÍSTICOS",
	"7990200": "SERVIÇOS DE RESERVAS E OUTROS SERVIÇOS DE TURISMO NÃO ESPECIFICADOS ANTERIORMENTE",
	"8011101": "ATIVIDADES DE VIGILÂNCIA E SEGURANÇA PRIVADA",
	"8011102": "SERVIÇOS DE ADESTRAMENTO DE CÃES DE GUARDA",
	"8012900": "ATIVIDADES DE TRANSPORTE DE VALORES",
	"8020001": "ATIVIDADES DE MONITORAMENTO DE SISTEMAS DE SEGURANÇA ELETRÔNICO",
	"8020002": "OUTRAS ATIVIDADES DE SERVIÇOS DE SEGURANÇA",
	"8030700": "ATIVIDADES DE INVESTIGAÇÃO PARTICULAR",
	"8111700": "SERVIÇOS COMBINADOS PARA APOIO A EDIFÍCIOS, EXCETO CONDOMÍNIOS PREDIAIS",
	"8112500": "CONDOMÍNIOS PREDIAIS",
	"8121400": "LIMPEZA EM PRÉDIOS E EM DOMICÍLIOS",
	"8122200": "IMUNIZAÇÃO E CONTROLE DE PRAGAS URBANAS",
	"8129000": "ATIVIDADES DE LIMPEZA NÃO ESPECIFICADAS ANTERIORMENTE",
	"8130300": "ATIVIDADES PAISAGÍSTICAS",
	"8211300": "SERVIÇOS COMBINADOS DE ESCRITÓRIO E APOIO ADMINISTRATIVO",
	"8219901": "FOTOCÓPIAS",
	"8219999":
		"PREPARAÇÃO DE DOCUMENTOS E SERVIÇOS ESPECIALIZADOS DE APOIO ADMINISTRATIVO NÃO ESPECIFICADOS ANTERIORMENTE",
	"8220200": "ATIVIDADES DE TELEATENDIMENTO",
	"8230001": "SERVIÇOS DE ORGANIZAÇÃO DE FEIRAS, CONGRESSOS, EXPOSIÇÕES E FESTAS",
	"8230002": "CASAS DE FESTAS E EVENTOS",
	"8291100": "ATIVIDADES DE COBRANÇAS E INFORMAÇÕES CADASTRAIS",
	"8292000": "ENVASAMENTO E EMPACOTAMENTO SOB CONTRATO",
	"8299701": "MEDIÇÃO DE CONSUMO DE ENERGIA ELÉTRICA, GÁS E ÁGUA",
	"8299702": "EMISSÃO DE VALES ALIMENTAÇÃO, VALES TRANSPORTE E SIMILARES",
	"8299703": "SERVIÇOS DE GRAVAÇÃO DE CARIMBOS, EXCETO CONFECÇÃO",
	"8299704": "LEILOEIROS INDEPENDENTES",
	"8299705": "SERVIÇOS DE LEVANTAMENTO DE FUNDOS SOB CONTRATO",
	"8299706": "CASAS LOTÉRICAS",
	"8299707": "SALAS DE ACESSO À INTERNET",
	"8299799":
		"OUTRAS ATIVIDADES DE SERVIÇOS PRESTADOS PRINCIPALMENTE ÀS EMPRESAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"8411600": "ADMINISTRAÇÃO PÚBLICA EM GERAL",
	"8412400":
		"REGULAÇÃO DAS ATIVIDADES DE SAÚDE, EDUCAÇÃO, SERVIÇOS CULTURAIS E OUTROS SERVIÇOS SOCIAIS",
	"8413200": "REGULAÇÃO DAS ATIVIDADES ECONÔMICAS",
	"8421300": "RELAÇÕES EXTERIORES",
	"8422100": "DEFESA",
	"8423000": "JUSTIÇA",
	"8424800": "SEGURANÇA E ORDEM PÚBLICA",
	"8425600": "DEFESA CIVIL",
	"8430200": "SEGURIDADE SOCIAL OBRIGATÓRIA",
	"8511200": "EDUCAÇÃO INFANTIL - CRECHE",
	"8512100": "EDUCAÇÃO INFANTIL - PRÉESCOLA",
	"8513900": "ENSINO FUNDAMENTAL",
	"8520100": "ENSINO MÉDIO",
	"8531700": "EDUCAÇÃO SUPERIOR - GRADUAÇÃO",
	"8532500": "EDUCAÇÃO SUPERIOR - GRADUAÇÃO E PÓS GRADUAÇÃO",
	"8533300": "EDUCAÇÃO SUPERIOR - PÓS GRADUAÇÃO E EXTENSÃO",
	"8541400": "EDUCAÇÃO PROFISSIONAL DE NÍVEL TÉCNICO",
	"8542200": "EDUCAÇÃO PROFISSIONAL DE NÍVEL TECNOLÓGICO",
	"8550301": "ADMINISTRAÇÃO DE CAIXAS ESCOLARES",
	"8550302": "ATIVIDADES DE APOIO À EDUCAÇÃO, EXCETO CAIXAS ESCOLARES",
	"8591100": "ENSINO DE ESPORTES",
	"8592901": "ENSINO DE DANÇA",
	"8592902": "ENSINO DE ARTES CÊNICAS, EXCETO DANÇA",
	"8592903": "ENSINO DE MÚSICA",
	"8592999": "ENSINO DE ARTE E CULTURA NÃO ESPECIFICADO ANTERIORMENTE",
	"8593700": "ENSINO DE IDIOMAS",
	"8599601": "FORMAÇÃO DE CONDUTORES",
	"8599602": "CURSOS DE PILOTAGEM",
	"8599603": "TREINAMENTO EM INFORMÁTICA",
	"8599604": "TREINAMENTO EM DESENVOLVIMENTO PROFISSIONAL E GERENCIAL",
	"8599605": "CURSOS PREPARATÓRIOS PARA CONCURSOS",
	"8599699": "OUTRAS ATIVIDADES DE ENSINO NÃO ESPECIFICADAS ANTERIORMENTE",
	"8610101":
		"ATIVIDADES DE ATENDIMENTO HOSPITALAR, EXCETO PRONTO SOCORRO E UNIDADES PARA ATENDIMENTO A URGÊNCIAS",
	"8610102":
		"ATIVIDADES DE ATENDIMENTO EM PRONTO SOCORRO E UNIDADES HOSPITALARES PARA ATENDIMENTO A URGÊNCIAS",
	"8621601": "UTI MÓVEL",
	"8621602": "SERVIÇOS MÓVEIS DE ATENDIMENTO A URGÊNCIAS, EXCETO POR UTI MÓVEL",
	"8622400":
		"SERVIÇOS DE REMOÇÃO DE PACIENTES, EXCETO OS SERVIÇOS MÓVEIS DE ATENDIMENTO A URGÊNCIAS",
	"8630501":
		"ATIVIDADE MÉDICA AMBULATORIAL COM RECURSOS PARA REALIZAÇÃO DE PROCEDIMENTOS CIRÚRGICOS",
	"8630502": "ATIVIDADE MÉDICA AMBULATORIAL COM RECURSOS PARA REALIZAÇÃO DE EXAMES COMPLEMENTARES",
	"8630503": "ATIVIDADE MÉDICA AMBULATORIAL RESTRITA A CONSULTAS",
	"8630504": "ATIVIDADE ODONTOLÓGICA",
	"8630506": "SERVIÇOS DE VACINAÇÃO E IMUNIZAÇÃO HUMANA",
	"8630507": "ATIVIDADES DE REPRODUÇÃO HUMANA ASSISTIDA",
	"8630599": "ATIVIDADES DE ATENÇÃO AMBULATORIAL NÃO ESPECIFICADAS ANTERIORMENTE",
	"8640201": "LABORATÓRIOS DE ANATOMIA PATOLÓGICA E CITOLÓGICA",
	"8640202": "LABORATÓRIOS CLÍNICOS",
	"8640203": "SERVIÇOS DE DIÁLISE E NEFROLOGIA",
	"8640204": "SERVIÇOS DE TOMOGRAFIA",
	"8640205": "SERVIÇOS DE DIAGNÓSTICO POR IMAGEM COM USO DE RADIAÇÃO IONIZANTE, EXCETO TOMOGRAFIA",
	"8640206": "SERVIÇOS DE RESSONÂNCIA MAGNÉTICA",
	"8640207":
		"SERVIÇOS DE DIAGNÓSTICO POR IMAGEM SEM USO DE RADIAÇÃO IONIZANTE, EXCETO RESSONÂNCIA MAGNÉTICA",
	"8640208": "SERVIÇOS DE DIAGNÓSTICO POR REGISTRO GRÁFICO - ECG, EEG E OUTROS EXAMES ANÁLOGOS",
	"8640209": "SERVIÇOS DE DIAGNÓSTICO POR MÉTODOS ÓPTICOS - ENDOSCOPIA E OUTROS EXAMES ANÁLOGOS",
	"8640210": "SERVIÇOS DE QUIMIOTERAPIA",
	"8640211": "SERVIÇOS DE RADIOTERAPIA",
	"8640212": "SERVIÇOS DE HEMOTERAPIA",
	"8640213": "SERVIÇOS DE LITOTRIPCIA",
	"8640214": "SERVIÇOS DE BANCOS DE CÉLULAS E TECIDOS HUMANOS",
	"8640299":
		"ATIVIDADES DE SERVIÇOS DE COMPLEMENTAÇÃO DIAGNÓSTICA E TERAPÊUTICA NÃO ESPECIFICADAS ANTERIORMENTE",
	"8650001": "ATIVIDADES DE ENFERMAGEM",
	"8650002": "ATIVIDADES DE PROFISSIONAIS DA NUTRIÇÃO",
	"8650003": "ATIVIDADES DE PSICOLOGIA E PSICANÁLISE",
	"8650004": "ATIVIDADES DE FISIOTERAPIA",
	"8650005": "ATIVIDADES DE TERAPIA OCUPACIONAL",
	"8650006": "ATIVIDADES DE FONOAUDIOLOGIA",
	"8650007": "ATIVIDADES DE TERAPIA DE NUTRIÇÃO ENTERAL E PARENTERAL",
	"8650099": "ATIVIDADES DE PROFISSIONAIS DA ÁREA DE SAÚDE NÃO ESPECIFICADAS ANTERIORMENTE",
	"8660700": "ATIVIDADES DE APOIO À GESTÃO DE SAÚDE",
	"8690901": "ATIVIDADES DE PRÁTICAS INTEGRATIVAS E COMPLEMENTARES EM SAÚDE HUMANA",
	"8690902": "ATIVIDADES DE BANCO DE LEITE HUMANO",
	"8690903": "ATIVIDADES DE ACUPUNTURA",
	"8690904": "ATIVIDADES DE PODOLOGIA",
	"8690999": "OUTRAS ATIVIDADES DE ATENÇÃO À SAÚDE HUMANA NÃO ESPECIFICADAS ANTERIORMENTE",
	"8711501": "CLÍNICAS E RESIDÊNCIAS GERIÁTRICAS",
	"8711502": "INSTITUIÇÕES DE LONGA PERMANÊNCIA PARA IDOSOS",
	"8711503": "ATIVIDADES DE ASSISTÊNCIA A DEFICIENTES FÍSICOS, IMUNODEPRIMIDOS E CONVALESCENTES",
	"8711504": "CENTROS DE APOIO A PACIENTES COM CÂNCER E COM AIDS",
	"8711505": "CONDOMÍNIOS RESIDENCIAIS PARA IDOSOS",
	"8712300":
		"ATIVIDADES DE FORNECIMENTO DE INFRAESTRUTURA DE APOIO E ASSISTÊNCIA A PACIENTE NO DOMICÍLIO",
	"8720401": "ATIVIDADES DE CENTROS DE ASSISTÊNCIA PSICOSSOCIAL",
	"8720499":
		"ATIVIDADES DE ASSISTÊNCIA PSICOSSOCIAL E À SAÚDE A PORTADORES DE DISTÚRBIOS PSÍQUICOS, DEFICIÊNCIA MENTAL E DEPENDÊNCIA QUÍMICA E GRUPOS SIMILARES NÃO ESPECIFICADAS ANTERIORMENTE",
	"8730101": "ORFANATOS",
	"8730102": "ALBERGUES ASSISTENCIAIS",
	"8730199":
		"ATIVIDADES DE ASSISTÊNCIA SOCIAL PRESTADAS EM RESIDÊNCIAS COLETIVAS E PARTICULARES NÃO ESPECIFICADAS ANTERIORMENTE",
	"8800600": "SERVIÇOS DE ASSISTÊNCIA SOCIAL SEM ALOJAMENTO",
	"9001901": "PRODUÇÃO TEATRAL",
	"9001902": "PRODUÇÃO MUSICAL",
	"9001903": "PRODUÇÃO DE ESPETÁCULOS DE DANÇA",
	"9001904": "PRODUÇÃO DE ESPETÁCULOS CIRCENSES, DE MARIONETES E SIMILARES",
	"9001905": "PRODUÇÃO DE ESPETÁCULOS DE RODEIOS, VAQUEJADAS E SIMILARES",
	"9001906": "ATIVIDADES DE SONORIZAÇÃO E DE ILUMINAÇÃO",
	"9001999":
		"ARTES CÊNICAS, ESPETÁCULOS E ATIVIDADES COMPLEMENTARES NÃO ESPECIFICADAS ANTERIORMENTE",
	"9002701": "ATIVIDADES DE ARTISTAS PLÁSTICOS, JORNALISTAS INDEPENDENTES E ESCRITORES",
	"9002702": "RESTAURAÇÃO DE OBRAS DE ARTE",
	"9003500": "GESTÃO DE ESPAÇOS PARA ARTES CÊNICAS, ESPETÁCULOS E OUTRAS ATIVIDADES ARTÍSTICAS",
	"9101500": "ATIVIDADES DE BIBLIOTECAS E ARQUIVOS",
	"9102301":
		"ATIVIDADES DE MUSEUS E DE EXPLORAÇÃO DE LUGARES E PRÉDIOS HISTÓRICOS E ATRAÇÕES SIMILARES",
	"9102302": "RESTAURAÇÃO E CONSERVAÇÃO DE LUGARES E PRÉDIOS HISTÓRICOS",
	"9103100":
		"ATIVIDADES DE JARDINS BOTÂNICOS, ZOOLÓGICOS, PARQUES NACIONAIS, RESERVAS ECOLÓGICAS E ÁREAS DE PROTEÇÃO AMBIENTAL",
	"9200301": "CASAS DE BINGO",
	"9200302": "EXPLORAÇÃO DE APOSTAS EM CORRIDAS DE CAVALOS",
	"9200399": "EXPLORAÇÃO DE JOGOS DE AZAR E APOSTAS NÃO ESPECIFICADOS ANTERIORMENTE",
	"9311500": "GESTÃO DE INSTALAÇÕES DE ESPORTES",
	"9312300": "CLUBES SOCIAIS, ESPORTIVOS E SIMILARES",
	"9313100": "ATIVIDADES DE CONDICIONAMENTO FÍSICO",
	"9319101": "PRODUÇÃO E PROMOÇÃO DE EVENTOS ESPORTIVOS",
	"9319199": "OUTRAS ATIVIDADES ESPORTIVAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"9321200": "PARQUES DE DIVERSÃO E PARQUES TEMÁTICOS",
	"9329801": "DISCOTECAS, DANCETERIAS, SALÕES DE DANÇA E SIMILARES",
	"9329802": "EXPLORAÇÃO DE BOLICHES",
	"9329803": "EXPLORAÇÃO DE JOGOS DE SINUCA, BILHAR E SIMILARES",
	"9329804": "EXPLORAÇÃO DE JOGOS ELETRÔNICOS RECREATIVOS",
	"9329899": "OUTRAS ATIVIDADES DE RECREAÇÃO E LAZER NÃO ESPECIFICADAS ANTERIORMENTE",
	"9411100": "ATIVIDADES DE ORGANIZAÇÕES ASSOCIATIVAS PATRONAIS E EMPRESARIAIS",
	"9412001": "ATIVIDADES DE FISCALIZAÇÃO PROFISSIONAL",
	"9412099": "OUTRAS ATIVIDADES ASSOCIATIVAS PROFISSIONAIS",
	"9420100": "ATIVIDADES DE ORGANIZAÇÕES SINDICAIS",
	"9430800": "ATIVIDADES DE ASSOCIAÇÕES DE DEFESA DE DIREITOS SOCIAIS",
	"9491000": "ATIVIDADES DE ORGANIZAÇÕES RELIGIOSAS OU FILOSÓFICAS",
	"9492800": "ATIVIDADES DE ORGANIZAÇÕES POLÍTICAS",
	"9493600": "ATIVIDADES DE ORGANIZAÇÕES ASSOCIATIVAS LIGADAS À CULTURA E À ARTE",
	"9499500": "ATIVIDADES ASSOCIATIVAS NÃO ESPECIFICADAS ANTERIORMENTE",
	"9511800": "REPARAÇÃO E MANUTENÇÃO DE COMPUTADORES E DE EQUIPAMENTOS PERIFÉRICOS",
	"9512600": "REPARAÇÃO E MANUTENÇÃO DE EQUIPAMENTOS DE COMUNICAÇÃO",
	"9521500": "REPARAÇÃO E MANUTENÇÃO DE EQUIPAMENTOS ELETROELETRÔNICOS DE USO PESSOAL E DOMÉSTICO",
	"9529101": "REPARAÇÃO DE CALÇADOS, DE BOLSAS E ARTIGOS DE VIAGEM",
	"9529102": "CHAVEIROS",
	"9529103": "REPARAÇÃO DE RELÓGIOS",
	"9529104": "REPARAÇÃO DE BICICLETAS, TRICICLOS E OUTROS VEÍCULOS NÃO MOTORIZADOS",
	"9529105": "REPARAÇÃO DE ARTIGOS DO MOBILIÁRIO",
	"9529106": "REPARAÇÃO DE JÓIAS",
	"9529199":
		"REPARAÇÃO E MANUTENÇÃO DE OUTROS OBJETOS E EQUIPAMENTOS PESSOAIS E DOMÉSTICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"9601701": "LAVANDERIAS",
	"9601702": "TINTURARIAS",
	"9601703": "TOALHEIROS",
	"9602501": "CABELEIREIROS, MANICURE E PEDICURE",
	"9602502": "ATIVIDADES DE ESTÉTICA E OUTROS SERVIÇOS DE CUIDADOS COM A BELEZA",
	"9603301": "GESTÃO E MANUTENÇÃO DE CEMITÉRIOS",
	"9603302": "SERVIÇOS DE CREMAÇÃO",
	"9603303": "SERVIÇOS DE SEPULTAMENTO",
	"9603304": "SERVIÇOS DE FUNERÁRIAS",
	"9603305": "SERVIÇOS DE SOMATOCONSERVAÇÃO",
	"9603399": "ATIVIDADES FUNERÁRIAS E SERVIÇOS RELACIONADOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"9609202": "AGÊNCIAS MATRIMONIAIS",
	"9609204": "EXPLORAÇÃO DE MÁQUINAS DE SERVIÇOS PESSOAIS ACIONADAS POR MOEDA",
	"9609205": "ATIVIDADES DE SAUNA E BANHOS",
	"9609206": "SERVIÇOS DE TATUAGEM E COLOCAÇÃO DE PIERCING",
	"9609207": "ALOJAMENTO DE ANIMAIS DOMÉSTICOS",
	"9609208": "HIGIENE E EMBELEZAMENTO DE ANIMAIS DOMÉSTICOS",
	"9609299": "OUTRAS ATIVIDADES DE SERVIÇOS PESSOAIS NÃO ESPECIFICADAS ANTERIORMENTE",
	"9700500": "SERVIÇOS DOMÉSTICOS",
	"9900800": "ORGANISMOS INTERNACIONAIS E OUTRAS INSTITUIÇÕES EXTRATERRITORIAIS",
	"0111301": "CULTIVO DE ARROZ",
	"0111302": "CULTIVO DE MILHO",
	"0111303": "CULTIVO DE TRIGO",
	"0111399": "CULTIVO DE OUTROS CEREAIS NÃO ESPECIFICADOS ANTERIORMENTE",
	"0112101": "CULTIVO DE ALGODÃO HERBÁCEO",
	"0112102": "CULTIVO DE JUTA",
	"0112199": "CULTIVO DE OUTRAS FIBRAS DE LAVOURA TEMPORÁRIA NÃO ESPECIFICADAS ANTERIORMENTE",
	"0113000": "CULTIVO DE CANA DE AÇÚCAR",
	"0114800": "CULTIVO DE FUMO",
	"0115600": "CULTIVO DE SOJA",
	"0116401": "CULTIVO DE AMENDOIM",
	"0116402": "CULTIVO DE GIRASSOL",
	"0116403": "CULTIVO DE MAMONA",
	"0116499": "CULTIVO DE OUTRAS OLEAGINOSAS DE LAVOURA TEMPORÁRIA NÃO ESPECIFICADAS ANTERIORMENTE",
	"0119901": "CULTIVO DE ABACAXI",
	"0119902": "CULTIVO DE ALHO",
	"0119903": "CULTIVO DE BATATA INGLESA",
	"0119904": "CULTIVO DE CEBOLA",
	"0119905": "CULTIVO DE FEIJÃO",
	"0119906": "CULTIVO DE MANDIOCA",
	"0119907": "CULTIVO DE MELÃO",
	"0119908": "CULTIVO DE MELANCIA",
	"0119909": "CULTIVO DE TOMATE RASTEIRO",
	"0119999": "CULTIVO DE OUTRAS PLANTAS DE LAVOURA TEMPORÁRIA NÃO ESPECIFICADAS ANTERIORMENTE",
	"0121101": "HORTICULTURA, EXCETO MORANGO",
	"0121102": "CULTIVO DE MORANGO",
	"0122900": "CULTIVO DE FLORES E PLANTAS ORNAMENTAIS",
	"0131800": "CULTIVO DE LARANJA",
	"0132600": "CULTIVO DE UVA",
	"0133401": "CULTIVO DE AÇAÍ",
	"0133402": "CULTIVO DE BANANA",
	"0133403": "CULTIVO DE CAJU",
	"0133404": "CULTIVO DE CÍTRICOS, EXCETO LARANJA",
	"0133405": "CULTIVO DE COCO DA BAÍA",
	"0133406": "CULTIVO DE GUARANÁ",
	"0133407": "CULTIVO DE MAÇÃ",
	"0133408": "CULTIVO DE MAMÃO",
	"0133409": "CULTIVO DE MARACUJÁ",
	"0133410": "CULTIVO DE MANGA",
	"0133411": "CULTIVO DE PÊSSEGO",
	"0133499": "CULTIVO DE FRUTAS DE LAVOURA PERMANENTE NÃO ESPECIFICADAS ANTERIORMENTE",
	"0134200": "CULTIVO DE CAFÉ",
	"0135100": "CULTIVO DE CACAU",
	"0139301": "CULTIVO DE CHÁ DA ÍNDIA",
	"0139302": "CULTIVO DE ERVA MATE",
	"0139303": "CULTIVO DE PIMENTA DO REINO",
	"0139304": "CULTIVO DE PLANTAS PARA CONDIMENTO, EXCETO PIMENTA DO REINO",
	"0139305": "CULTIVO DE DENDÊ",
	"0139306": "CULTIVO DE SERINGUEIRA",
	"0139399": "CULTIVO DE OUTRAS PLANTAS DE LAVOURA PERMANENTE NÃO ESPECIFICADAS ANTERIORMENTE",
	"0141501": "PRODUÇÃO DE SEMENTES CERTIFICADAS, EXCETO DE FORRAGEIRAS PARA PASTO",
	"0141502": "PRODUÇÃO DE SEMENTES CERTIFICADAS DE FORRAGEIRAS PARA FORMAÇÃO DE PASTO",
	"0142300": "PRODUÇÃO DE MUDAS E OUTRAS FORMAS DE PROPAGAÇÃO VEGETAL, CERTIFICADAS",
	"0151201": "CRIAÇÃO DE BOVINOS PARA CORTE",
	"0151202": "CRIAÇÃO DE BOVINOS PARA LEITE",
	"0151203": "CRIAÇÃO DE BOVINOS, EXCETO PARA CORTE E LEITE",
	"0152101": "CRIAÇÃO DE BUFALINOS",
	"0152102": "CRIAÇÃO DE EQÜINOS",
	"0152103": "CRIAÇÃO DE ASININOS E MUARES",
	"0153901": "CRIAÇÃO DE CAPRINOS",
	"0153902": "CRIAÇÃO DE OVINOS, INCLUSIVE PARA PRODUÇÃO DE LÃ",
	"0154700": "CRIAÇÃO DE SUÍNOS",
	"0155501": "CRIAÇÃO DE FRANGOS PARA CORTE",
	"0155502": "PRODUÇÃO DE PINTOS DE UM DIA",
	"0155503": "CRIAÇÃO DE OUTROS GALINÁCEOS, EXCETO PARA CORTE",
	"0155504": "CRIAÇÃO DE AVES, EXCETO GALINÁCEOS",
	"0155505": "PRODUÇÃO DE OVOS",
	"0159801": "APICULTURA",
	"0159802": "CRIAÇÃO DE ANIMAIS DE ESTIMAÇÃO",
	"0159803": "CRIAÇÃO DE ESCARGÔ",
	"0159804": "CRIAÇÃO DE BICHO DA SEDA",
	"0159899": "CRIAÇÃO DE OUTROS ANIMAIS NÃO ESPECIFICADOS ANTERIORMENTE",
	"0161001": "SERVIÇO DE PULVERIZAÇÃO E CONTROLE DE PRAGAS AGRÍCOLAS",
	"0161002": "SERVIÇO DE PODA DE ÁRVORES PARA LAVOURAS",
	"0161003": "SERVIÇO DE PREPARAÇÃO DE TERRENO, CULTIVO E COLHEITA",
	"0161099": "ATIVIDADES DE APOIO À AGRICULTURA NÃO ESPECIFICADAS ANTERIORMENTE",
	"0162801": "SERVIÇO DE INSEMINAÇÃO ARTIFICIAL DE ANIMAIS",
	"0162802": "SERVIÇO DE TOSQUIAMENTO DE OVINOS",
	"0162803": "SERVIÇO DE MANEJO DE ANIMAIS",
	"0162899": "ATIVIDADES DE APOIO À PECUÁRIA NÃO ESPECIFICADAS ANTERIORMENTE",
	"0163600": "ATIVIDADES DE PÓS COLHEITA",
	"0170900": "CAÇA E SERVIÇOS RELACIONADOS",
	"0210101": "CULTIVO DE EUCALIPTO",
	"0210102": "CULTIVO DE ACÁCIA NEGRA",
	"0210103": "CULTIVO DE PINUS",
	"0210104": "CULTIVO DE TECA",
	"0210105": "CULTIVO DE ESPÉCIES MADEIREIRAS, EXCETO EUCALIPTO, ACÁCIA NEGRA, PINUS E TECA",
	"0210106": "CULTIVO DE MUDAS EM VIVEIROS FLORESTAIS",
	"0210107": "EXTRAÇÃO DE MADEIRA EM FLORESTAS PLANTADAS",
	"0210108": "PRODUÇÃO DE CARVÃO VEGETAL - FLORESTAS PLANTADAS",
	"0210109": "PRODUÇÃO DE CASCA DE ACÁCIA NEGRA - FLORESTAS PLANTADAS",
	"0210199":
		"PRODUÇÃO DE PRODUTOS NÃO MADEIREIROS NÃO ESPECIFICADOS ANTERIORMENTE EM FLORESTAS PLANTADAS",
	"0220901": "EXTRAÇÃO DE MADEIRA EM FLORESTAS NATIVAS",
	"0220902": "PRODUÇÃO DE CARVÃO VEGETAL - FLORESTAS NATIVAS",
	"0220903": "COLETA DE CASTANHA DO PARÁ EM FLORESTAS NATIVAS",
	"0220904": "COLETA DE LÁTEX EM FLORESTAS NATIVAS",
	"0220905": "COLETA DE PALMITO EM FLORESTAS NATIVAS",
	"0220906": "CONSERVAÇÃO DE FLORESTAS NATIVAS",
	"0220999":
		"COLETA DE PRODUTOS NÃO MADEIREIROS NÃO ESPECIFICADOS ANTERIORMENTE EM FLORESTAS NATIVAS",
	"0230600": "ATIVIDADES DE APOIO À PRODUÇÃO FLORESTAL",
	"0311601": "PESCA DE PEIXES EM ÁGUA SALGADA",
	"0311602": "PESCA DE CRUSTÁCEOS E MOLUSCOS EM ÁGUA SALGADA",
	"0311603": "COLETA DE OUTROS PRODUTOS MARINHOS",
	"0311604": "ATIVIDADES DE APOIO À PESCA EM ÁGUA SALGADA",
	"0312401": "PESCA DE PEIXES EM ÁGUA DOCE",
	"0312402": "PESCA DE CRUSTÁCEOS E MOLUSCOS EM ÁGUA DOCE",
	"0312403": "COLETA DE OUTROS PRODUTOS AQUÁTICOS DE ÁGUA DOCE",
	"0312404": "ATIVIDADES DE APOIO À PESCA EM ÁGUA DOCE",
	"0321301": "CRIAÇÃO DE PEIXES EM ÁGUA SALGADA E SALOBRA",
	"0321302": "CRIAÇÃO DE CAMARÕES EM ÁGUA SALGADA E SALOBRA",
	"0321303": "CRIAÇÃO DE OSTRAS E MEXILHÕES EM ÁGUA SALGADA E SALOBRA",
	"0321304": "CRIAÇÃO DE PEIXES ORNAMENTAIS EM ÁGUA SALGADA E SALOBRA",
	"0321305": "ATIVIDADES DE APOIO À AQÜICULTURA EM ÁGUA SALGADA E SALOBRA",
	"0321399":
		"CULTIVOS E SEMICULTIVOS DA AQÜICULTURA EM ÁGUA SALGADA E SALOBRA NÃO ESPECIFICADOS ANTERIORMENTE",
	"0322101": "CRIAÇÃO DE PEIXES EM ÁGUA DOCE",
	"0322102": "CRIAÇÃO DE CAMARÕES EM ÁGUA DOCE",
	"0322103": "CRIAÇÃO DE OSTRAS E MEXILHÕES EM ÁGUA DOCE",
	"0322104": "CRIAÇÃO DE PEIXES ORNAMENTAIS EM ÁGUA DOCE",
	"0322105": "RANICULTURA",
	"0322106": "CRIAÇÃO DE JACARÉ",
	"0322107": "ATIVIDADES DE APOIO À AQÜICULTURA EM ÁGUA DOCE",
	"0322199": "CULTIVOS E SEMICULTIVOS DA AQÜICULTURA EM ÁGUA DOCE NÃO ESPECIFICADOS ANTERIORMENTE",
	"0500301": "EXTRAÇÃO DE CARVÃO MINERAL",
	"0500302": "BENEFICIAMENTO DE CARVÃO MINERAL",
	"0600001": "EXTRAÇÃO DE PETRÓLEO E GÁS NATURAL",
	"0600002": "EXTRAÇÃO E BENEFICIAMENTO DE XISTO",
	"0600003": "EXTRAÇÃO E BENEFICIAMENTO DE AREIAS BETUMINOSAS",
	"0710301": "EXTRAÇÃO DE MINÉRIO DE FERRO",
	"0710302": "PELOTIZAÇÃO, SINTERIZAÇÃO E OUTROS BENEFICIAMENTOS DE MINÉRIO DE FERRO",
	"0721901": "EXTRAÇÃO DE MINÉRIO DE ALUMÍNIO",
	"0721902": "BENEFICIAMENTO DE MINÉRIO DE ALUMÍNIO",
	"0722701": "EXTRAÇÃO DE MINÉRIO DE ESTANHO",
	"0722702": "BENEFICIAMENTO DE MINÉRIO DE ESTANHO",
	"0723501": "EXTRAÇÃO DE MINÉRIO DE MANGANÊS",
	"0723502": "BENEFICIAMENTO DE MINÉRIO DE MANGANÊS",
	"0724301": "EXTRAÇÃO DE MINÉRIO DE METAIS PRECIOSOS",
	"0724302": "BENEFICIAMENTO DE MINÉRIO DE METAIS PRECIOSOS",
	"0725100": "EXTRAÇÃO DE MINERAIS RADIOATIVOS",
	"0729401": "EXTRAÇÃO DE MINÉRIOS DE NIÓBIO E TITÂNIO",
	"0729402": "EXTRAÇÃO DE MINÉRIO DE TUNGSTÊNIO",
	"0729403": "EXTRAÇÃO DE MINÉRIO DE NÍQUEL",
	"0729404":
		"EXTRAÇÃO DE MINÉRIOS DE COBRE, CHUMBO, ZINCO E OUTROS MINERAIS METÁLICOS NÃO FERROSOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"0729405":
		"BENEFICIAMENTO DE MINÉRIOS DE COBRE, CHUMBO, ZINCO E OUTROS MINERAIS METÁLICOS NÃO FERROSOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"0810001": "EXTRAÇÃO DE ARDÓSIA E BENEFICIAMENTO ASSOCIADO",
	"0810002": "EXTRAÇÃO DE GRANITO E BENEFICIAMENTO ASSOCIADO",
	"0810003": "EXTRAÇÃO DE MÁRMORE E BENEFICIAMENTO ASSOCIADO",
	"0810004": "EXTRAÇÃO DE CALCÁRIO E DOLOMITA E BENEFICIAMENTO ASSOCIADO",
	"0810005": "EXTRAÇÃO DE GESSO E CAULIM",
	"0810006": "EXTRAÇÃO DE AREIA, CASCALHO OU PEDREGULHO E BENEFICIAMENTO ASSOCIADO",
	"0810007": "EXTRAÇÃO DE ARGILA E BENEFICIAMENTO ASSOCIADO",
	"0810008": "EXTRAÇÃO DE SAIBRO E BENEFICIAMENTO ASSOCIADO",
	"0810009": "EXTRAÇÃO DE BASALTO E BENEFICIAMENTO ASSOCIADO",
	"0810010": "BENEFICIAMENTO DE GESSO E CAULIM ASSOCIADO À EXTRAÇÃO",
	"0810099":
		"EXTRAÇÃO E BRITAMENTO DE PEDRAS E OUTROS MATERIAIS PARA CONSTRUÇÃO E BENEFICIAMENTO ASSOCIADO",
	"0891600":
		"EXTRAÇÃO DE MINERAIS PARA FABRICAÇÃO DE ADUBOS, FERTILIZANTES E OUTROS PRODUTOS QUÍMICOS",
	"0892401": "EXTRAÇÃO DE SAL MARINHO",
	"0892402": "EXTRAÇÃO DE SAL GEMA",
	"0892403": "REFINO E OUTROS TRATAMENTOS DO SAL",
	"0893200": "EXTRAÇÃO DE GEMAS (PEDRAS PRECIOSAS E SEMIPRECIOSAS)",
	"0899101": "EXTRAÇÃO DE GRAFITA",
	"0899102": "EXTRAÇÃO DE QUARTZO",
	"0899103": "EXTRAÇÃO DE AMIANTO",
	"0899199": "EXTRAÇÃO DE OUTROS MINERAIS NÃO METÁLICOS NÃO ESPECIFICADOS ANTERIORMENTE",
	"0910600": "ATIVIDADES DE APOIO À EXTRAÇÃO DE PETRÓLEO E GÁS NATURAL",
	"0990401": "ATIVIDADES DE APOIO À EXTRAÇÃO DE MINÉRIO DE FERRO",
	"0990402": "ATIVIDADES DE APOIO À EXTRAÇÃO DE MINERAIS METÁLICOS NÃO FERROSOS",
	"0990403": "ATIVIDADES DE APOIO À EXTRAÇÃO DE MINERAIS NÃO METÁLICOS",
};

/**
 * Shape a CNAE subclass code has to be written in: the 7 digits, optionally split into the
 * printed `NNNN-N/NN` groups by a single whitespace or mask character.
 */
export const CNAE_FORMAT_REGEX = /^\d{4}[\s.\-/]?\d[\s.\-/]?\d{2}$/;
